import * as $ from 'jquery';
import 'bootstrap';
import 'datepicker';
import 'selectize';
import * as moment from 'moment';
import { mHolidays } from "../m-holidays";
import { searchFlightHotelSubmit } from "./search-flight-hotel-submission";
import { bookingFormCommon } from "../c005-bookingform-common";

export class flightHotelFormContent {
    private searchFlightHotelSubmit = new searchFlightHotelSubmit();
    private mHolidaysBase:any = new mHolidays();
    private bcommon = new bookingFormCommon();
    $scope: any = $('#searchFlightHotel');
    $scopeHotel: any = $('#hotel');
    $scopeFlight:any = $('#flightHotel');
    $instance: any;

    init(): void {
        let _self = this;
        let $searchFlightHotel = $('.searchFlightHotel');
        let $travelType = $searchFlightHotel.find('input[name="travelType"]');
        let $travelTypeVal;
        let $passengerDetails: any = $('.passenger-details');
        let $passengerDetailsSelected: any = $('.passenger-details-selected');
        let $adultCountSelector: any = $passengerDetailsSelected.find('select[name="adults_count"]');
        let $childrenCountSelector: any = $passengerDetailsSelected.find('select[name="children_count"]');
        let $childrenAgeSection: any = $('.passenger-details-selected .child-age-section');
        let $childrenAges: any = $('.passenger-details-selected .child-age-section .ages');
        let $passengerLimitErrorSelector: any = $('.passenger-limit-error');
        let $current_tab: any;
        let $totalRoomCount: any = 1;


        $adultCountSelector.val(1);
        $childrenCountSelector.val(0);
        $searchFlightHotel.find('#flightHotel_deals .passenger-details-selected').find('select[name="adults_count"]').val(2);
        $searchFlightHotel.find('#flightHotel .passenger-details-selected').find('select[name="adults_count"]').val(2);
        $searchFlightHotel.find('#hotel .passenger-details-selected').find('select[name="adults_count"]').val(2);
        // enabling toyr and transfer
        let $isenabletransfer_tour: any = $('#isEnabletourtravel').val();
        let $isenabledeals: any = $('#isEnabledeals').val();
        let $isenableflighthotel: any = $('#flightHotel2').val();
        if ($isenabletransfer_tour=='true')
        {
           $('#tour').removeClass('hide');
           $('#transfer').removeClass('hide');
           $('#flightHotel_deals').removeClass('hide');
           $('.isEnabletourtravel').removeClass('hide');
           

        }
        else
        {
            $('#tour').addClass('hide');
            $('#transfer').addClass('hide');
            $('#flightHotel_deals').addClass('hide');
            $('.isEnabletourtravel').addClass('hide');
        }
        if ($isenabledeals=='true')
        {
            $('#flightHotel_deals').removeClass('hide');
            $('.isEnabledeals').removeClass('hide');
            $('.nav-pills').addClass('isdeals');
        }
        else
        {
            $('#flightHotel_deals').addClass('hide');
            $('.isEnabledeals').addClass('hide');
            $('.searchFlightHotel .nav-pills').removeClass('isdeals');
        }
        //CUG page specific code.
        // $('#searchFlightHotel.searchTUI-CUG .nav-pills li').not('.seperator').filter(":visible:first").find('a').trigger('click');
        //$($($($(".nav-pills.isdeals input")[3]).next()[0]).find('a'));
        for (let i = 0; i < $(".nav-pills li").not('.seperator').length; i++) {
            if ($($(".nav-pills input")[i]).val() == 'true') {
                $($($($(".nav-pills input")[i]).next()[0]).children()[1]).trigger('click');
                break;
            } 
        }
        //---
        $(".add_room_three").hide();  
         $("#room2_adults_count_hotel").val(0);
       $("#room3_adults_count_hotel").val(0);
        var num = $("#room1_child_count").val();
        if(num==0){
            $("#child_age_list_room1").html("<br/><br/>");
        }
        var num = $("#room2_child_count").val();
        if(num==0){
            $("#child_age_list_room2").html("<br/><br/>");
        }
        var num = $("#room3_child_count").val();
        if(num==0){
            $("#child_age_list_room3").html("<br/><br/>");
        }
        if($(".room_two").hasClass("hide")){
            if($('#hotel').css('display') == 'block') {
                $("#room2_adults_count_hotel").val(0);
                $("#room3_adults_count_hotel").val(0);
            }
            else{
                $("#room2_adults_count").val(0) ;
            }
             
        }
        
        if($(".room_three").hasClass("hide")){
            if($('#hotel').css('display') == 'block') {
                $("#room3_adults_count_hotel").val(0) ;
            }
            else{
                $("#room3_adults_count").val(0) ;
            }
        }
        $(".add_room_two").click(function(){
           if($('#hotel').css('display') == 'block') {
                $current_tab = '#hotel';
            }
            else if($('#flightHotel_deals').css('display') == 'block')
            {
                $current_tab = '#flightHotel_deals';
            }
            else if($('#flightHotel2').css('display') == 'block')
            {
                $current_tab = '#flightHotel2';
            }
            else{
                $current_tab = '#flightHotel';
            }
            $($current_tab +" .room_two").removeClass("hide");
            $totalRoomCount = 2;
            $($current_tab +' .rooms_count').text($totalRoomCount >0 ? $totalRoomCount +" "  : 1 );

            $($current_tab +" .add_room_two").hide();
            if($($current_tab +" .room_three").hasClass("hide")){
                $($current_tab +" .room_two i").addClass("fa fa-times close");
            }  
            else{
                $($current_tab +" .room_two i").removeClass("fa fa-times close");
                $($current_tab +" .room_three i").addClass("fa fa-times close");
            }   
                  if($current_tab == '#hotel'){
                    $("#room2_adults_count_hotel").val(1);
                    $("#room3_adults_count_hotel").val(0);
                    $($current_tab +" .add_room_three").show();
                    _self.displayPassengerCount();

                  }
                  else if($('#flightHotel_deals').css('display') == 'block')
                  {
                    $("#room2_adults_count_deals").val(1);
                    $("#room3_adults_count_deals").val(0);
                    $($current_tab +" .add_room_three").show();
                    _self.dealsdisplayPassengerCount();
                  }
                  else if($('#flightHotel2').css('display') == 'block')
                  {
                    $("#room2_adults_count__flighthotel").val(1);
                    $("#room3_adults_count__flighthotel").val(0);
                    $($current_tab +" .add_room_three").show();
                    _self.flighthoteldisplayPassengerCount();
                  }
                  else {
                    $($current_tab +" #room2_adults_count").val(1) ;
                    var room1_adults =  parseInt($($current_tab +" #room1_adults_count").val());
                    var room2_adults =  parseInt($($current_tab +" #room2_adults_count").val());
                    var room2_child =  parseInt($($current_tab +" #room2_child_count").val());

                    if((room1_adults+room2_adults )< 9 && (room2_adults + room2_child) < 9)
                        {
                                $($current_tab +" .add_room_three").show();
                        }
                    else
                        {
                            $($current_tab +" .add_room_three").hide();
                        }   
                        _self.errorValidationDisplay();
                    }
            
            
        });      
        $("#transfer-options input[type=radio]").click(function(event:any) {
            let journeytype  = $("#transfer-options input[type='radio']:checked").val();
            if(journeytype != 'Return'){
                $('#dropoffDate').hide();
            }else{
                $('#dropoffDate').show(); 
            }
            if(journeytype != 'ToAirport'){
                $('#transferpickup .hotelInputClass').attr('placeholder', 'City/ Airport*');
                $('#transferdrop .hotelInputClass').attr('placeholder', 'Hotel*');
                $('.from-display-tui-container').hide();
                $('.hotel-display-tui-container').hide();
                $('#transferpickup .hotelInputClass').val("");
                $('#transferdrop .hotelInputClass').val("");
            }else{
                $('#transferpickup .hotelInputClass').attr('placeholder', 'Hotel*');
                $('#transferdrop .hotelInputClass').attr('placeholder', 'Airport*');
                $('.from-display-tui-container').hide();
                $('.hotel-display-tui-container').hide();
                $('#transferpickup .hotelInputClass').val("");
                $('#transferdrop .hotelInputClass').val("");
            }
          });

        $(".add_room_three").click(function(){
            if($('#hotel').css('display') == 'block') {
                $current_tab = '#hotel';
                $("#room3_adults_count_hotel").val(1);
                _self.displayPassengerCount();
            }
            else if($('#flightHotel_deals').css('display') == 'block')
            {
                $current_tab = '#flightHotel_deals';
                _self.dealsdisplayPassengerCount();
            }
            else if($('#flightHotel2').css('display') == 'block')
            {
                $current_tab = '#flightHotel2';
                $($current_tab +" #room3_adults_count__flighthotel").val(1) ; 
                _self.flighthoteldisplayPassengerCount();
            }
            else{
                $current_tab = '#flightHotel';
            }
            $totalRoomCount = 3;
            $($current_tab +' .rooms_count').text($totalRoomCount >0 ? $totalRoomCount+" "  : 1 );
            $($current_tab +" .room_three").removeClass("hide");
            $($current_tab +" .add_room_three").hide();
            $($current_tab +" .room_two i").removeClass("fa fa-times close");
            $($current_tab +" .room_three i").addClass("fa fa-times close");
            $($current_tab +" #room3_adults_count").val(1) ;   
            $($current_tab +" #room3_adults_count_deals").val(1) ; 
            
            _self.errorValidationDisplay();         
        });
        $("#room1_child_count").change(function() {
            var num = $("#room1_child_count").val();
            $("#child_age_list_room1").html("");
           
            for(var i=0; i<num ; i++)
            {
            $("#child_age_list_room1").append('<div class="control-label selectlist_child" id="child_age_list_room1" for="adults_count">Child/Teenager '+ (i +1)+' age<div class="travel-input"> <select id="child_age" name="child_age"><option selected value="2">2 Years</option><option value="3">3 Years</option><option value="4">4 Years</option><option value="5">5 Years</option><option value="6">6 Years</option><option value="7">7 Years</option><option value="8">8 Years</option><option value="9">9 Years</option><option value="10">10 Years</option><option value="11">11 Years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div></div>');
                  
            }       


            if(num==0){
            $("#child_age_list_room1").html("<br/><br/>");
            }

            }); 


            $(".room2_close").click(function(){
                if($('#hotel').css('display') == 'block') {
                    $current_tab = '#hotel';
                }
                else if($('#flightHotel_deals').css('display') == 'block')
                {
                    $current_tab = '#flightHotel_deals';
                }
                else if($('#flightHotel2').css('display') == 'block')
                {
                    $current_tab = '#flightHotel2';
                }
                else{
                    $current_tab = '#flightHotel';
                }

                $($current_tab +" .room_two").addClass("hide");
                $totalRoomCount = 1;
                $($current_tab +' .rooms_count').text($totalRoomCount >0 ? $totalRoomCount+" "  : 1 );

                if($current_tab == '#hotel'){
                    $($current_tab +" #room2_adults_count_hotel").val(0) ;
                    $($current_tab +" #room2_child_count_hotel").val(0) ;
                    $($current_tab +" #room2_infants_count_hotel").val(0) ;
                    $($current_tab +" #child_age_list_room2_hotel").html("");
                    $($current_tab +" .add_room_three").hide();
                    $($current_tab +" .add_room_two").show();
                    _self.displayPassengerCount();
                  }
                  else if($('#flightHotel_deals').css('display') == 'block')
                  {
                    $($current_tab +" #room2_adults_count_deals").val(0) ;
                    $($current_tab +" #room2_child_count_deals").val(0) ;
                    $($current_tab +" #room2_infants_count_deals").val(0) ;
                    _self.dealsdisplayPassengerCount();
                    $($current_tab +" #child_age_list_room2_deals").html("");
                    var room1_adults =  parseInt($($current_tab +" #room1_adults_count_deals").val());
                    var room1_child =  parseInt($($current_tab +" #room1_child_count_deals").val());
                    $($current_tab +" .add_room_three").hide();

                    if(room1_adults < 9 && (room1_adults + room1_child) < 9)
                       {                  
       
                           if($($current_tab +" .room_two").hasClass("hide")){
                               $($current_tab +" .add_room_two").show();
                           }
                          
                       }
                   else
                       {
                           $($current_tab +" .add_room_two").hide();
                       } 
                  }
                  else if($('#flightHotel2').css('display') == 'block')
                  {
                    $($current_tab +" #room2_adults_count__flighthotel").val(0) ;
                    $($current_tab +" #room2_child_count__flighthotel").val(0) ;
                    $($current_tab +" #room2_infants_count__flighthotel").val(0) ;
                    _self.flighthoteldisplayPassengerCount();
                    $($current_tab +" #child_age_list_room2__flighthotel").html("");
                    var room1_adults =  parseInt($($current_tab +" #room1_adults_count__flighthotel").val());
                    var room1_child =  parseInt($($current_tab +" #room1_child_count__flighthotel").val());
                    $($current_tab +" .add_room_three").hide();

                    if(room1_adults < 9 && (room1_adults + room1_child) < 9)
                       {                  
       
                           if($($current_tab +" .room_two").hasClass("hide")){
                               $($current_tab +" .add_room_two").show();
                           }
                          
                       }
                   else
                       {
                           $($current_tab +" .add_room_two").hide();
                       } 
                  }else {
                    $($current_tab +" #room2_adults_count").val(0) ;
                    $($current_tab +" #room2_child_count").val(0) ;
                    $($current_tab +" #room2_infants_count").val(0) ;
                    _self.errorValidationDisplay();
                    $($current_tab +" #child_age_list_room2").html("");
                    var room1_adults =  parseInt($($current_tab +" #room1_adults_count").val());
                    var room1_child =  parseInt($($current_tab +" #room1_child_count").val());
                    $($current_tab +" .add_room_three").hide();

                    if(room1_adults < 9 && (room1_adults + room1_child) < 9)
                       {                  
       
                           if($($current_tab +" .room_two").hasClass("hide")){
                               $($current_tab +" .add_room_two").show();
                           }
                          
                       }
                   else
                       {
                           $($current_tab +" .add_room_two").hide();
                       } 
                  }
  

                        
            });            
            
            $(".room3_close").click(function(){
                if($('#hotel').css('display') == 'block') {
                    $current_tab = '#hotel';
                }
                else if($('#flightHotel_deals').css('display') == 'block')
                {
                    $current_tab = '#flightHotel_deals';
                }
                else if($('#flightHotel2').css('display') == 'block')
                {
                    $current_tab = '#flightHotel2';
                }
                else{
                    $current_tab = '#flightHotel';
                }
                $($current_tab +" .room_three").addClass("hide");
                $totalRoomCount = 2;
                $($current_tab + ' .rooms_count').text($totalRoomCount >0 ? $totalRoomCount +" " : 1 );

                $($current_tab +" .room_two i").addClass("fa fa-times close");
          
                var room1_adults =  parseInt($($current_tab +" #room1_adults_count").val());
                var room1_child =  parseInt($($current_tab +" #room1_child_count").val());
        
                var room2_adults_deals =  parseInt($($current_tab +" #room2_adults_count_deals").val());
                var room2_child_deals =  parseInt($($current_tab +" #room2_child_count_deals").val());
                var room1_adults_deals =  parseInt($($current_tab +" #room1_adults_count_deals").val());
                var room1_child_deals=  parseInt($($current_tab +" #room1_child_count_deals").val());
        
                var room2_adults =  parseInt($($current_tab +" #room2_adults_count").val());
                var room2_child =  parseInt($($current_tab +" #room2_child_count").val());
                if($current_tab == '#hotel'){
                    $($current_tab +" #room3_adults_count_hotel").val(0) ;                
                    $($current_tab +" #room3_child_count_hotel").val(0) ;
                    $($current_tab +" #room3_infants_count_hotel").val(0) ;
                    $($current_tab +" #child_age_list_room3_hotel").html("");
                    $($current_tab +" .add_room_three").show();
                    $($current_tab +" .add_room_two").hide();
                    _self.displayPassengerCount();
                  }
                  else if($('#flightHotel_deals').css('display') == 'block')
                  {
                    $($current_tab +" #room3_adults_count_deals").val(0) ;                
                    $($current_tab +" #room3_child_count_deals").val(0) ;
                    $($current_tab +" #room3_infants_count_deals").val(0) ;
                    _self.dealsdisplayPassengerCount();
                    $($current_tab +" #child_age_list_room3_deals").html("");
    
                    if((room1_adults+room2_adults+ room1_child+room2_child)< 9)
                    {
                        if($($current_tab +" .room_three").hasClass("hide")){
                            $($current_tab +" .add_room_three").show();
                        }
                        if($($current_tab +" .add_room_two").css('display') == 'inline'){
                            $($current_tab +" .add_room_three").hide();
                        }
                        
                    }
                    else
                        {
                            $($current_tab +" .add_room_three").hide();
                        }   
                        _self.dealsdisplayPassengerCount();
                  }
                  else if($('#flightHotel2').css('display') == 'block')
                  {
                    $($current_tab +" #room3_adults_count__flighthotel").val(0) ;                
                    $($current_tab +" #room3_child_count__flighthotel").val(0) ;
                    $($current_tab +" #room3_infants_count__flighthotel").val(0) ;
                    $($current_tab +" .add_room_three").show();
                    $($current_tab +" .add_room_two").hide();
                    $($current_tab +" #child_age_list_room3__flighthotel").html("");
                    _self.flighthoteldisplayPassengerCount();

                  }else{
                    $($current_tab +" #room3_adults_count").val(0) ;                
                    $($current_tab +" #room3_child_count").val(0) ;
                    $($current_tab +" #room3_infants_count").val(0) ;
                    _self.errorValidationDisplay();
                    $($current_tab +" #child_age_list_room3").html("");
    
                    if((room1_adults+room2_adults+ room1_child+room2_child)< 9)
                    {
                        if($($current_tab +" .room_three").hasClass("hide")){
                            $($current_tab +" .add_room_three").show();
                        }
                        if($($current_tab +" .add_room_two").css('display') == 'inline'){
                            $($current_tab +" .add_room_three").hide();
                        }
                        
                    }
                    else
                        {
                            $($current_tab +" .add_room_three").hide();
                        }   
                        _self.errorValidationDisplay();
                  }

            });


        $("#room2_child_count").change(function() {
            var num = $("#room2_child_count").val();
            $("#child_age_list_room2").html("");
            
            for(var i=0; i<num ; i++){
            $("#child_age_list_room2").append('<div class="control-label selectlist_child" id="child_age_list_room2" for="adults_count">Child/Teenager '+ (i +1)+' age<div class="travel-input"> <select id="child_age" name="child_age"><option selected value="2">2 Years</option><option value="3">3 Years</option><option value="4">4 Years</option><option value="5">5 Years</option><option value="6">6 Years</option><option value="7">7 Years</option><option value="8">8 Years</option><option value="9">9 Years</option><option value="10">10 Years</option><option value="11">11 Years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div></div>');
            }
            if(num==0){
                $("#child_age_list_room2").html("<br/><br/>");
            }
        });
        $("#room3_child_count").change(function() {
            var num = $("#room3_child_count").val();
            $("#child_age_list_room3").html("");
            
            for(var i=0; i<num ; i++){
            $("#child_age_list_room3").append('<div class="control-label selectlist_child" id="child_age_list_room3" for="adults_count">Child/Teenager '+ (i +1)+' age<div class="travel-input"> <select id="child_age" name="child_age"><option selected value="2">2 Years</option><option value="3">3 Years</option><option value="4">4 Years</option><option value="5">5 Years</option><option value="6">6 Years</option><option value="7">7 Years</option><option value="8">8 Years</option><option value="9">9 Years</option><option value="10">10 Years</option><option value="11">11 Years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div></div>');
            }
            if(num==0){
                $("#child_age_list_room3").html("<br/><br/>");
            }

        });

        $("#room1_adults_count, #room1_child_count").change(function() {
            
        var room1_adults =  parseInt($("#room1_adults_count").val());
        var room1_child =  parseInt($("#room1_child_count").val());
        var room1_infants =  parseInt($("#room1_infants_count").val());

        var room2_adults =  parseInt($("#room2_adults_count").val());
        var room2_child =  parseInt($("#room2_child_count").val());
        var room2_infants =  parseInt($("#room2_infants_count").val());

        var room3_adults =  parseInt($("#room3_adults_count").val());
        var room3_child =  parseInt($("#room3_child_count").val());
        var room3_infants =  parseInt($("#room3_infants_count").val());
        if($('#hotel').css('display') == 'block') {
            $current_tab = '#hotel';
        }
        else if($('#flightHotel_deals').css('display') == 'block')
        {
            $current_tab = '#flightHotel_deals';
        }
        else if($('#flightHotel2').css('display') == 'block'){
            $current_tab = '#flightHotel2'
        }
        else{
            $current_tab = '#flightHotel';
        }
             if(room1_adults < 9 && (room1_adults + room1_child) < 9)
                {                  

                    if($($current_tab+ " .room_two").hasClass("hide")){
                        $($current_tab+ " .add_room_two").show();
                    }
                   
                }
            else
                {
                    $($current_tab+ " .add_room_two").hide();
                    $($current_tab+ " .add_room_three").hide();
                }   
            });

            $("#room2_adults_count, #room2_child_count,#room1_adults_count, #room1_child_count").change(function() {
                if($('#hotel').css('display') == 'block') {
                    $current_tab = '#hotel';
                }
                else if($('#flightHotel_deals').css('display') == 'block')
                {
                    $current_tab = '#flightHotel_deals';
                }
                else if($('#flightHotel2').css('display') == 'block')
                {
                    $current_tab = '#flightHotel2';
                }
                else{
                    $current_tab = '#flightHotel';
                }
                var room1_adults =  parseInt($("#room1_adults_count").val());
                var room1_child =  parseInt($("#room1_child_count").val());
                var room1_infants =  parseInt($("#room1_infants_count").val());

                var room2_adults =  parseInt($("#room2_adults_count").val());
                var room2_child =  parseInt($("#room2_child_count").val());
                var room2_infants =  parseInt($("#room2_infants_count").val());

                var room3_adults =  parseInt($("#room3_adults_count").val());
                var room3_child =  parseInt($("#room3_child_count").val());
                var room3_infants =  parseInt($("#room3_infants_count").val());
                if((room1_adults+room2_adults+ room1_child+room2_child)< 9)
                        {
                            if($($current_tab+ " .room_three").hasClass("hide")){
                                $($current_tab+ " .add_room_three").show();
                            }
                            if($($current_tab+ " .add_room_two").css('display') == 'inline'){
                                $($current_tab+ " .add_room_three").hide();
                            }
                            
                        }
                else
                    {
                        $($current_tab+ " .add_room_three").hide();
                    }   
                });            
                var num1 = parseInt($("#room1_adults_count").val());
                var num2 = parseInt($("#room2_adults_count").val());
                var num3 = parseInt($("#room3_adults_count").val());
                let $adultCount: any = num1 + num2 +num3;
        
                var n1 = parseInt($("#room1_child_count").val());
                var n2 = parseInt($("#room2_child_count").val());
                var n3 = parseInt($("#room3_child_count").val());
                let $childrenCount: any = n1 + n2 +n3;
                
                var m1 = parseInt($("#room1_infants_count").val());
                var m2 = parseInt($("#room2_infants_count").val());
                var m3 = parseInt($("#room3_infants_count").val());
                let $infants_total:any = m1 + m2 +m3;
                let $totalTravellersCount: any = $adultCount + $childrenCount +$infants_total;
        

                $("#room1_adults_count, #room2_adults_count, #room3_adults_count,#room1_child_count, #room2_child_count, #room3_child_count,#room1_infants_count, #room2_infants_count, #room3_infants_count ").change(function() {
                    _self.errorValidationDisplay();
      
                  });
                  $("#room1_adults_count_hotel, #room2_adults_count_hotel, #room3_adults_count_hotel,#room1_child_count_hotel, #room2_child_count_hotel, #room3_child_count_hotel,#room1_infants_count_hotel, #room2_infants_count_hotel, #room3_infants_count_hotel").change(function() {
                    _self.displayPassengerCount();
                    
                  });
                  $("#room1_adults_count_deals, #room2_adults_count_deals, #room3_adults_count_deals,#room1_child_count_deals, #room2_child_count_deals, #room3_child_count_deals,#room1_infants_count_deals, #room2_infants_count_deals, #room3_infants_count_deals").change(function() {
                    _self.dealsdisplayPassengerCount();
                    
                  });
                  $("#room1_adults_count__flighthotel, #room2_adults_count__flighthotel, #room3_adults_count__flighthotel,#room1_child_count__flighthotel, #room2_child_count__flighthotel, #room3_child_count__flighthotel,#room1_infants_count__flighthotel, #room2_infants_count__flighthotel, #room3_infants_count__flighthotel").change(function() {
                    _self.flighthoteldisplayPassengerCount();
                    
                  });
        
        $travelType.click(function () {
            $travelTypeVal = $searchFlightHotel.find('input[name="travelType"]:checked').val();
            if ($travelTypeVal === 'fh') {
                $('.searchFlightHotel .fh-container').show();
                $('.searchFlightHotel .h-container').hide();
            } else {
                $('.searchFlightHotel .fh-container').hide();
                $('.searchFlightHotel .h-container').show();
            }
        });

        $(document).on('click', function () {
            $passengerDetailsSelected.hide();

        });

        $passengerDetails.click(function (evt: any) {
            $passengerDetailsSelected.show();
            evt.preventDefault();
            evt.stopPropagation();
        });

        $passengerDetailsSelected.click(function (evt: any) {
            evt.preventDefault();
            evt.stopPropagation();
        });

        $passengerDetailsSelected.find('button, input, select').on('click', function (evt: any) {
            evt.preventDefault();
            evt.stopPropagation();
        });

        $passengerDetailsSelected.find('.fa-angle-up').on('click', function (evt: any) {
            $passengerDetailsSelected.hide();
        });
       
        $("#room1_child_count_hotel").change(function() {
            var num = $("#room1_child_count_hotel").val();
            $("#child_age_list_room1_hotel").html("");
           
            for(var i=0; i<num ; i++){
            $("#child_age_list_room1_hotel").append('<div class="control-label selectlist_child" for="adults_count">Child/Teenager '+ (i +1)+' age<div class="travel-input"> <select id="child_age" name="child_age"><option selected value="2">2 Years</option><option value="3">3 Years</option><option value="4">4 Years</option><option value="5">5 Years</option><option value="6">6 Years</option><option value="7">7 Years</option><option value="8">8 Years</option><option value="9">9 Years</option><option value="10">10 Years</option><option value="11">11 Years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div></div>');
                  
        }
    });
       
    $("#room2_child_count_hotel").change(function() {
        var num = $("#room2_child_count_hotel").val();
        $("#child_age_list_room2_hotel").html("");
       
        for(var i=0; i<num ; i++){
        $("#child_age_list_room2_hotel").append('<div class="control-label selectlist_child" for="adults_count">Child/Teenager '+ (i +1)+' age<div class="travel-input"> <select id="child_age" name="child_age"><option selected value="2">2 Years</option><option value="3">3 Years</option><option value="4">4 Years</option><option value="5">5 Years</option><option value="6">6 Years</option><option value="7">7 Years</option><option value="8">8 Years</option><option value="9">9 Years</option><option value="10">10 Years</option><option value="11">11 Years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div></div>');
              
    }
});        
$("#room3_child_count_hotel").change(function() {
    var num = $("#room3_child_count_hotel").val();
    $("#child_age_list_room3_hotel").html("");
   
    for(var i=0; i<num ; i++){
    $("#child_age_list_room3_hotel").append('<div class="control-label selectlist_child" for="adults_count">Child/Teenager '+ (i +1)+' age<div class="travel-input"> <select id="child_age" name="child_age"><option selected value="2">2 Years</option><option value="3">3 Years</option><option value="4">4 Years</option><option value="5">5 Years</option><option value="6">6 Years</option><option value="7">7 Years</option><option value="8">8 Years</option><option value="9">9 Years</option><option value="10">10 Years</option><option value="11">11 Years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div></div>');
          
}
});     
        $($childrenCountSelector).on('change', function () {


        if($('#hotel').css('display') == 'block') {
            $childrenCountSelector = $('#hotel select[name="children_count"]');
            $childrenAgeSection    = $('#hotel #child_age_list_room3_hotel');
            // $childrenAges          = $('#hotel .child-age-section .ages'); 
           // $childrenAges          = $('#hotel #child_age_list_room3_hotel'); 
        }
        else{
            $childrenCountSelector = $('#flightHotel select[name="children_count"]');
            $childrenAgeSection    = $('#flightHotel .child-age-section');
            $childrenAges          = $('#flightHotel .child-age-section .ages');     
        }
            let noOfChildrenSelected = $childrenCountSelector.val();
            let childAgeCountExist = $childrenAges.find('.age').length;
            if (noOfChildrenSelected > 0) {
                if (childAgeCountExist < noOfChildrenSelected) {
                    for (var i = 0; i < (noOfChildrenSelected - childAgeCountExist); i++) {
                        $childrenAges.append('<div class="age row"><div class="col-lg-3 col-md-3 col-sm-3"><label>Child ' + ((childAgeCountExist + 1) + i) + '</label></div><div class="col-lg-9 col-md-9 col-sm-9"><select class="children-age" id="children_age" name="children_age[]"><option value="0" selected>0 year</option><option value="1" selected>1 year</option><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option></select></div></div>');
                    }
                } else if (noOfChildrenSelected < childAgeCountExist) {
                    for (var i = childAgeCountExist; i > noOfChildrenSelected; i--) {
                        $childrenAgeSection.find('#child_age_list_room3_hotel').children().eq(i - 1).remove();
                        $childrenAgeSection.find('#child_age_list_room3_hotel').children().eq(i - 1).detach();
                    }
                }
                $childrenAgeSection.show();
            } else {
                $childrenAges.html('');
                $childrenAgeSection.hide();
            }
            _self.passengerLimitCheck();
        });

        $($childrenCountSelector).on('focus', function () {
            _self.passengerLimitCheck();
        });

        $($childrenCountSelector).on('keyup', function () {
            _self.passengerLimitCheck();
        });
        
        $($adultCountSelector).on('change', function () {
            if ($adultCountSelector.val() < 1) {
                $($adultCountSelector).val(1);
            }
            _self.passengerLimitCheck();
        });
        
        $($adultCountSelector).on('focus', function () {
            _self.passengerLimitCheck();
        });
        
        $($adultCountSelector).on('keyup', function () {
            _self.passengerLimitCheck();
        });
    // transfer validations


    $("#transfer_child_count").change(function() 
    {
        var num = $("#transfer_child_count").val();
        $("#child_age_list_room_transfer").html("");       
        for(var i=0; i<num ; i++)
        {
        $("#child_age_list_room_transfer").append('<div class="control-label selectlist_child" id="child_age_list_room_transfer'+i+'" for="adults_count">Child/Teenager '+ (i +1)+' age<div class="travel-input"> <select id="child_age" name="child_age"><option selected value="1">1 Years</option><option  value="2">2 Years</option><option value="3">3 Years</option><option value="4">4 Years</option><option value="5">5 Years</option><option value="6">6 Years</option><option value="7">7 Years</option><option value="8">8 Years</option><option value="9">9 Years</option><option value="10">10 Years</option><option value="11">11 Years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div></div>');              
        }       
        if(num==0)
        {
        $("#child_age_list_room_transfer").html("<br/><br/>");
        }
        _self.transferdisplayPassengerCount();
    }); 

    $("#transfer_adults_count").change(function() 
    {
     _self.transferdisplayPassengerCount();
    });

        let isedge = navigator.userAgent.indexOf("Edge") > -1;		
		let isexplorer= typeof document !== 'undefined' && !!(document as any).documentMode && !isedge;
		if (isedge || isexplorer) {
			$( '.hotelInputClass' ).on( 'click', function() {
				$( this ).prop( 'readonly', '' );
				$( this ).focus();
			});
			// making the input readonly
			$( '.hotelInputClass' ).on( 'blur', function() {
				$( this ).prop( 'readonly', 'readonly' );
			});
		}
    }
    transferdisplayPassengerCount() {
        var $adult = parseInt($("#transfer_adults_count").val());  
        var $child = parseInt($("#transfer_child_count").val());
        let $totalTravellersCount_transfer: any = $adult + $child ;
        $('#transfer .total-nos').text($totalTravellersCount_transfer>0 ? $totalTravellersCount_transfer : 1);
        
    } 
    displayPassengerCount() {
    if(!$('#hotel .room_two').hasClass('hide'))
    {
        var num2 =  parseInt($("#room2_adults_count_hotel").val()) || 0;
        n2 = parseInt($("#room2_child_count_hotel").val())|| 0;
        m2 = parseInt($("#room2_infants_count_hotel").val())|| 0;
    }
    else{
        $("#room2_adults_count_hotel").val(0);
        $("#room3_adults_count_hotel").val(0);
        num2 = 0;
        num3 = 0;
    }
    var num1 = parseInt($("#room1_adults_count_hotel").val());
    var num2 = parseInt($("#room2_adults_count_hotel").val());
    var num3 = parseInt($("#room3_adults_count_hotel").val());
    if(isNaN(num2))
    num2=0;  
   if(isNaN(num3))
    num3=0
    let $adultCount_hotel: any = num1 + num2 +num3;

    var n1 = parseInt($("#room1_child_count_hotel").val());
    var n2 = parseInt($("#room2_child_count_hotel").val());
    var n3 = parseInt($("#room3_child_count_hotel").val());
    if(isNaN(n2))
    n2=0;  
   if(isNaN(n3))
    n3=0;
    let $childrenCount_hotel: any = n1 + n2 +n3;
    
    var m1 = parseInt($("#room1_infants_count_hotel").val());
    var m2 = parseInt($("#room2_infants_count_hotel").val());
    var m3 = parseInt($("#room3_infants_count_hotel").val());
    if(isNaN(m2))
    m2=0;  
   if(isNaN(m3))
    m3=0;
    let $infants_total_hotel:any = m1 + m2 +m3;

    let $totalTravellersCount_hotel: any = $adultCount_hotel + $childrenCount_hotel +$infants_total_hotel;
    $('#hotel .total-nos').text($totalTravellersCount_hotel>0 ? $totalTravellersCount_hotel : 1);

 
    }
    dealsdisplayPassengerCount() {
        if(!$('#flightHotel_deals .room_two').hasClass('hide'))
        {
            var num2 =  parseInt($("#room2_adults_count_deals").val()) || 0;
            n2 = parseInt($("#room2_child_count_deals").val())|| 0;
            m2 = parseInt($("#room2_infants_count_deals").val())|| 0;
        }
        else{
            $("#room2_adults_count_deals").val(0);
            $("#room3_adults_count_deals").val(0);
            num2 = 0;
            num3 = 0;
        }
        var num1 = parseInt($("#room1_adults_count_deals").val());
        var num2 = parseInt($("#room2_adults_count_deals").val());
        var num3 = parseInt($("#room3_adults_count_deals").val());
        if(isNaN(num2))
        num2=0;  
       if(isNaN(num3))
        num3=0
        let $adultCount_hotel: any = num1 + num2 +num3;
    
        var n1 = parseInt($("#room1_child_count_deals").val());
        var n2 = parseInt($("#room2_child_count_deals").val());
        var n3 = parseInt($("#room3_child_count_deals").val());
        if(isNaN(n2))
        n2=0;  
       if(isNaN(n3))
        n3=0;
        let $childrenCount_hotel: any = n1 + n2 +n3;
        
        var m1 = parseInt($("#room1_infants_count_deals").val());
        var m2 = parseInt($("#room2_infants_count_deals").val());
        var m3 = parseInt($("#room3_infants_count_deals").val());
        if(isNaN(m2))
        m2=0;  
       if(isNaN(m3))
        m3=0;
        let $infants_total_hotel:any = m1 + m2 +m3;
    
        let $totalTravellersCount_hotel: any = $adultCount_hotel + $childrenCount_hotel +$infants_total_hotel;
        $('#flightHotel_deals .total-nos').text($totalTravellersCount_hotel>0 ? $totalTravellersCount_hotel : 1);
    
     
        }
        /* Flight + Hotel PDP Travellers  */
        flighthoteldisplayPassengerCount() {
            if(!$('#flightHotel2 .room_two').hasClass('hide'))
            {
                var num2 =  parseInt($("#room2_adults_count__flighthotel").val()) || 0;
                n2 = parseInt($("#room2_child_count__flighthotel").val())|| 0;
                m2 = parseInt($("#room2_infants_count__flighthotel").val())|| 0;
            }
            else{
                $("#room2_adults_count__flighthotel").val(0);
                $("#room3_adults_count__flighthotel").val(0);
                num2 = 0;
                num3 = 0;
            }
            var num1 = parseInt($("#room1_adults_count__flighthotel").val());
            var num2 = parseInt($("#room2_adults_count__flighthotel").val());
            var num3 = parseInt($("#room3_adults_count__flighthotel").val());
            if(isNaN(num2))
            num2=0;  
           if(isNaN(num3))
            num3=0
            let $adultCount_hotel: any = num1 + num2 +num3;
        
            var n1 = parseInt($("#room1_child_count__flighthotel").val());
            var n2 = parseInt($("#room2_child_count__flighthotel").val());
            var n3 = parseInt($("#room3_child_count__flighthotel").val());
            if(isNaN(n2))
            n2=0;  
           if(isNaN(n3))
            n3=0;
            let $childrenCount_hotel: any = n1 + n2 +n3;
            
            var m1 = parseInt($("#room1_infants_count__flighthotel").val());
            var m2 = parseInt($("#room2_infants_count__flighthotel").val());
            var m3 = parseInt($("#room3_infants_count__flighthotel").val());
            if(isNaN(m2))
            m2=0;  
           if(isNaN(m3))
            m3=0;
            let $infants_total_hotel:any = m1 + m2 +m3;
        
            let $totalTravellersCount_hotel: any = $adultCount_hotel + $childrenCount_hotel +$infants_total_hotel;
            $('#flightHotel2 .total-nos').text($totalTravellersCount_hotel>0 ? $totalTravellersCount_hotel : 1);
        
         
            }
            
    errorValidationDisplay() {
        let $passengerLimitErrorSelector: any = $('.passenger-limit-error');     
        let $passengerDetails: any = $('#flightHotel .passenger-details');
        let $passengerDetailsSelected: any = $('#flightHotel .passenger-details-selected');
                var num1 = parseInt($("#room1_adults_count").val());
                var m1 = parseInt($("#room1_infants_count").val());
                var n1 = parseInt($("#room1_child_count").val()); 
                var n2=0;
                var n3=0;
                var m2=0;
                var m3=0;
                var num2=0;
                var num3=0;
                if(!$('#flightHotel .room_two').hasClass('hide'))
                {
                    var num2 =  parseInt($("#room2_adults_count").val()) || 0;
                    n2 = parseInt($("#room2_child_count").val())|| 0;
                    m2 = parseInt($("#room2_infants_count").val())|| 0;
                }
                if(!$('#flightHotel .room_three').hasClass('hide'))
                {
                    var num3 = parseInt($("#room3_adults_count").val()) || 0;
                    n3 = parseInt($("#room3_child_count").val()) || 0;
                    m3 = parseInt($("#room3_infants_count").val())|| 0;
                }

                let $adultCount: any = num1 + num2 +num3;
                let $childrenCount: any = n1 + n2 +n3;
                let $infants_total:any = m1 + m2 +m3;
                let $totalTravellersCount: any = $adultCount + $childrenCount +$infants_total;
                if(isNaN(num2))
                num2=0;  
            if(isNaN(num3))
                num3=0;
                // let $adultCount: any = num1 + num2 +num3;
                var n1 = parseInt($("#room1_child_count").val()); 
                // let $childrenCount: any = n1 + n2 +n3;
                if(isNaN(n2))
                n2=0;  
            if(isNaN(n3))
                n3=0;
                var m1 = parseInt($("#room1_infants_count").val());
                var m2 = parseInt($("#room2_infants_count").val());
                var m3 = parseInt($("#room3_infants_count").val());
                if(isNaN(m2))
                m2=0;  
            if(isNaN(num3))
                m3=0;
                // let $infants_total:any = m1 + m2 +m3;
                // let $totalTravellersCount: any = $adultCount + $childrenCount +$infants_total;
                $('#flightHotel .total-nos').text($totalTravellersCount>0 ? $totalTravellersCount : 1);

                var error_list =[];
                $passengerLimitErrorSelector.text('');
                if ($adultCount > 9) {
                    error_list.push('* Adults count cannot exceed 9');
                }    
                if (num1 < m1 || num2 < m2 || num3 < m3) {
                    error_list.push('* Infants count cannot exceed Adults count per room');
                }
                if (($childrenCount + $adultCount) > 9) {
                    error_list.push('* Children count and adult count cannot exceed 9');
                }
                if ($infants_total > 3) {
                    error_list.push('* Infants count cannot exceed 3');
                }     
                if ($childrenCount > 6) {
                    error_list.push('* Children count cannot exceed 6');
                }
                $.unique(error_list);
                if(error_list.length >0){
                    $passengerLimitErrorSelector.show();
                    for(var i=0; i<error_list.length; i++){
                        $passengerLimitErrorSelector.append(error_list[i]+"<br/>");
                    }
                    $passengerDetails.addClass('passenger-info-error');
                    $passengerDetailsSelected.addClass('passenger-info-error');
                }
                else{
                    $passengerLimitErrorSelector.hide();
                    $passengerLimitErrorSelector.text('');
                    $passengerDetails.removeClass('passenger-info-error');
                    $passengerDetailsSelected.removeClass('passenger-info-error');
                }       
    }
    
    passengerLimitCheck() {
        
        let $instance  = $('.searchFlightHotel');
        let $passengerDetails: any = $('.passenger-details');
        let $passengerDetailsSelected: any = $('.passenger-details-selected');
        // let $adultCount: any = parseInt($passengerDetailsSelected.find('select[name="adults_count"]').val());
        // let $childrenCount: any = parseInt($passengerDetailsSelected.find('select[name="children_count"]').val());
        // let $totalTravellersCount: any = $adultCount + $childrenCount;
        var num1 = parseInt($("#room1_adults_count").val());
        var num2 = parseInt($("#room2_adults_count").val());
        var num3 = parseInt($("#room3_adults_count").val());
        let $adultCount: any = num1 + num2 +num3;

        var n1 = parseInt($("#room1_child_count").val());
        var n2 = parseInt($("#room2_child_count").val());
        var n3 = parseInt($("#room3_child_count").val());
        let $childrenCount: any = n1 + n2 +n3;
        
        var m1 = parseInt($("#room1_infants_count").val());
        var m2 = parseInt($("#room2_infants_count").val());
        var m3 = parseInt($("#room3_infants_count").val());
        let $infants_total:any = m1 + m2 +m3;
        let $totalTravellersCount: any = $adultCount + $childrenCount +$infants_total;
        let $passengerLimitErrorSelector: any = $instance.find('.passenger-limit-error');
        let $totalTravelerDisplay:any = $instance.find('.passenger-details');
        if($('#hotel').css('display') == 'block') {
             $adultCount         = parseInt($('#hotel select[name="adults_count"]').val());
             $childrenCount      = parseInt($('#hotel select[name="children_count"]').val());
            //  $totalTravellersCount = $adultCount + $childrenCount;
          //  $('#hotel .total-nos').text($totalTravellersCount_hotel>0 ? $totalTravellersCount_hotel : 1);
            
            // if ($totalTravellersCount >= 2) {
            //     $('#hotel .traveler-count').html('Travellers');
			// }
            // else {
            //     $('#hotel .traveler-count').html('Traveller');                
            // }
        }else{
           // $('#flightHotel .total-nos').text($totalTravellersCount>0 ? $totalTravellersCount : 1);

            // if ($totalTravellersCount >= 2) {
            //     $('#flightHotel .traveler-count').html('Travellers');
			// }
            // else {
            //     $('#flightHotel .traveler-count').html('Traveller');                
            // }
        }
       
    }

    

	/**
	 * expand this instance of search panel
	 * extrapolate method so that it can be used elsewhere
	 * instead of just selectize.focus()
	 */
    searchPanelExpand(instance: any): void {
        let $deptDateContainer = instance.find('.dep-date');
        let $rtnDateContainer = instance.find('.rtn-date');
        let $trvInfoContainer = instance.find('.trv-info');
        let $cabinContainer = instance.find('.cabin-info');

        $deptDateContainer.show();
        $rtnDateContainer.show();
        $trvInfoContainer.show();
        $cabinContainer.show();
    }

	/**
	 * @function initSelectize
	 * mHolidays from location event handlers
	 * @param  {any} listItems [description]
	 * @return {any}           [description]
	 * !!! Properly scoped
	 */
    initSelectize(listItems: any): void {
        let _self = this;
        let curInstance = $('.searchFlightHotel');
        let selInstance = _self.$instance;
        let $fhToLocationContainer: any = $('#fhToLocationContainer');
        let $fhDepDateContainer: any = $('#depDate');
        let $fhRtnDateContainer: any = $('#rtnDate');
        let $fhFromLocation: any = $('.fh-from--location');
        let $fhFromSelectize: any;
        let $fromLocationSelectizeInput:any = $fhFromLocation.parent().find('.selectize-control .selectize-input');
        let $fhToLocation: any = $('.fh-to--location');
        let $fhToSelectize: any;

        $fhFromLocation.html(listItems);
        $fhFromLocation.selectize({
            onInitialize: function () {
                $fhFromSelectize = $($fhFromLocation[0].selectize.$control[0]);
            },
            onFocus: function () {
                _self.searchPanelExpand(curInstance);
                $fromLocationSelectizeInput.removeClass('has-error');
                
            },
            onChange: function (value: any) {
                if ($fhFromLocation.val() != '') {
                    $fhToLocationContainer.find('input[type="select-one"]').focus(); 
                    $fhFromLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
                    $fhToLocationContainer.css({'pointer-events':'auto', 'opacity':'1'}); 
                }
                else {
                    $fhToLocationContainer.css({'pointer-events':'none', 'opacity':'0.5'});                  
                    $fhToLocation[0].selectize.clear();
                }
                _self.mHolidaysBase.updateMholidaysOnDListOnFlowChange($fhFromLocation.val().trim(), $fhToLocation);
            },
            onBlur: function (data: any) {
            },
            onLoad: function (data: any) {
            },
            lockOptgroupOrder: true,
            searchField: ['text', 'optgroup'],
            placeholder: 'Departure *',
            selectOnTab: true
        });

        $fhToLocation.html(listItems);
        $fhToLocation.selectize({
            onInitialize: function () {
                $fhToSelectize = $($fhToLocation[0].selectize.$control[0]);
            },
            onFocus: function () {
                _self.searchPanelExpand(curInstance);
            },
            onChange: function (value: any) {
                if ($fhToLocation.val() != '') {
                    setTimeout(function () {
                        $fhDepDateContainer.find('input[name="start"]').focus();
                        $fhToLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
                    }, 300);
                }
            },
            onBlur: function (data: any) {
            },
            onLoad: function (data: any) {
            },
            lockOptgroupOrder: true,
            searchField: ['text', 'optgroup'],
            placeholder: 'Destination',
            selectOnTab: true
        });

        $(".fh-from--location").keydown(function (event: any) {
            if (event.keyCode === 9) {
                event.preventDefault();
                event.stopPropagation();
            }
        });
    }
    initSelectize_flighthotel(listItems: any): void {
        let _self = this;
        let curInstance = $('.searchFlightHotel');
        let selInstance = _self.$instance;
        let $fhToLocationContainer__flighthotel: any = $('#fhToLocationContainer__flighthotel');
        let $fhToLocationContainer: any = $('#fhToLocationContainer__flighthotel');
        let $fhHotelContainer: any = $('#hotelInputWrap__flighthotel');
        let $fhDepDateContainer: any = $('#depDate');
        let $fhRtnDateContainer: any = $('#rtnDate');
        let $fhFromLocation: any = $('.fh-from--location__flighthotel');
        let $fhFromSelectize: any;
        let $fromLocationSelectizeInput:any = $fhFromLocation.parent().find('.selectize-control .selectize-input');
        let $fhToLocation: any = $('.fh-to--location__flighthotel');
        let $fhToSelectize: any;
        let $flightHotelPdp: any = $('#flightHotel2');

        $fhFromLocation.html(listItems);
        $fhFromLocation.selectize({
            onInitialize: function () {
                $fhFromSelectize = $($fhFromLocation[0].selectize.$control[0]);
            },
            onFocus: function() {
                _self.searchPanelExpand(curInstance);
                $fromLocationSelectizeInput.removeClass('has-error');
            },
            onChange: function() {
                if ($fhFromLocation.val() != ''){
                    $fhToLocationContainer.find('input[type="select-one"]').focus(); 
                    $fhFromLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
                    $fhToLocationContainer__flighthotel.find('input[type="select-one"]').focus();
                    $fhToLocationContainer__flighthotel.css({'pointer-events':'auto', 'opacity':'1'}); 
                }else{
                    $fhToLocationContainer__flighthotel.css({'pointer-events':'none', 'opacity':'0.5'});                  
                    $fhToLocation[0].selectize.clear();
                }
                _self.mHolidaysBase.updateMholidaysPdpOnDListOnFlowChange($fhFromLocation.val().trim(), $fhToLocation);
            },
            onBlur: function (data: any) {

            },
            onLoad: function (data: any){

            },
            lockOptgroupOrder: true,
            searchFeild: ['text','optgroup'],
            placeholder: 'Departure *',
            selectOnTab: true

        });
        $fhToLocation.html(listItems);
        $fhToLocation.selectize({
            onInitialize: function () {
                $fhToSelectize = $($fhToLocation[0].selectize.$control[0]);
            },
            onFocus: function () {
                _self.searchPanelExpand(curInstance);
            },
            onChange: function (value: any) {
                if ($fhToLocation.val() != '') {                  
                    $fhToLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
                    $fhHotelContainer.css({'pointer-events':'auto', 'opacity':'1'}); 
                    setTimeout(function() {
                        $fhHotelContainer.find('#hotelInput__flighthotel').val('');
                        $fhHotelContainer.find('#hotelInputtoVal').val('');
                        $fhHotelContainer.find('#hotelInputVal').val('');
                        $fhHotelContainer.find('#hotelInput__flighthotel').trigger('click');
                    }, 400);                  
                }
                else {
                    $fhHotelContainer.css({'pointer-events':'none', 'opacity':'0.5'});
                }
            },
            onBlur: function (data: any) {
            },
            onLoad: function (data: any) {
            },
            lockOptgroupOrder: true,
            searchField: ['text', 'optgroup'],
            placeholder: 'Destination',
            selectOnTab: true
        });
        $(".fh-from--location_flighthotel").keydown(function (event: any) {
            if (event.keyCode === 9) {
                event.preventDefault();
                event.stopPropagation();
            }
        });

    }
    initSelectize_deals(listItems: any): void {
        let _self = this;
        let curInstance = $('.searchFlightHotel');
        let selInstance = _self.$instance;
        let $fhToLocationContainer_deals: any = $('#fhToLocationContainer_deals');
        let $fhToLocationContainer: any = $('#fhToLocationContainer_deals');
        let $fhDepDateContainer: any = $('#depDate');
        let $fhRtnDateContainer: any = $('#rtnDate');
        let $fhFromLocation: any = $('.fh-from--location_deals');
        let $fhFromSelectize: any;
        let $fromLocationSelectizeInput:any = $fhFromLocation.parent().find('.selectize-control .selectize-input');
        let $fhToLocation: any = $('.fh-to--location_deals');
        let $fhToSelectize: any;

        $fhFromLocation.html(listItems);
        $fhFromLocation.selectize({
            onInitialize: function () {
                $fhFromSelectize = $($fhFromLocation[0].selectize.$control[0]);
            },
            onFocus: function () {
                _self.searchPanelExpand(curInstance);
                $fromLocationSelectizeInput.removeClass('has-error');
                
            },
            onChange: function (value: any) {
                if ($fhFromLocation.val() != '') {
                    $fhToLocationContainer.find('input[type="select-one"]').focus(); 
                    $fhFromLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
                    $fhToLocationContainer_deals.find('input[type="select-one"]').focus();
                    $fhToLocationContainer_deals.css({'pointer-events':'auto', 'opacity':'1'}); 
                }
                else {
                    $fhToLocationContainer_deals.css({'pointer-events':'none', 'opacity':'0.5'});                  
                    $fhToLocation[0].selectize.clear();
                }
                _self.mHolidaysBase.updateMholidaysOnDListOnFlowChange($fhFromLocation.val().trim(), $fhToLocation);
            },
            onBlur: function (data: any) {
            },
            onLoad: function (data: any) {
            },
            lockOptgroupOrder: true,
            searchField: ['text', 'optgroup'],
            placeholder: 'Departure *',
            selectOnTab: true
        });

        $fhToLocation.html(listItems);
        $fhToLocation.selectize({
            onInitialize: function () {
                $fhToSelectize = $($fhToLocation[0].selectize.$control[0]);
            },
            onFocus: function () {
                _self.searchPanelExpand(curInstance);
            },
            onChange: function (value: any) {
                if ($fhToLocation.val() != '') {
                    $fhDepDateContainer.find('input[name="start"]').focus();
                    $fhToLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
                }
            },
            onBlur: function (data: any) {
            },
            onLoad: function (data: any) {
            },
            lockOptgroupOrder: true,
            searchField: ['text', 'optgroup'],
            placeholder: 'Destination',
            selectOnTab: true
        });

        $(".fh-from--location_deals").keydown(function (event: any) {
            if (event.keyCode === 9) {
                event.preventDefault();
                event.stopPropagation();
            }
        });
    }
    transferinitSelectize(listItems: any): void {
        let _self = this;
        let curInstance = $('#transfer');
        let $dropoffContainers: any = $('#dropoffContainer');
        let $pickupDateContainers: any = $('#pickupDate');
        let $pickupLocations: any = $('.pick-up--location');
        let $fhFromSelectize: any;
        let $pickupSelectizeInputs:any = $pickupLocations.parent().find('.selectize-control .selectize-input');
        let $dropoffLocations: any = $('.drop-off--location');
        let $fhToSelectize: any;
    
        $pickupLocations.html(listItems);
        $pickupLocations.selectize({
            onInitialize: function () {
                $fhFromSelectize = $($pickupLocations[0].selectize.$control[0]);
            },
            onFocus: function () {
                _self.searchPanelExpand(curInstance);
                $pickupSelectizeInputs.removeClass('has-error');
                
            },
            onChange: function (value: any) {
                if ($pickupLocations.val() != '') {
                    $dropoffContainers.find('input[type="select-one"]').focus();
                    $pickupLocations.parent().find('.selectize-control .selectize-input').removeClass('has-error');
                }
                _self.mHolidaysBase.updateMholidaysOnDListOnFlowChange($pickupLocations.val().trim(), $dropoffLocations);
            },
            onBlur: function (data: any) {
            },
            onLoad: function (data: any) {
            },
            lockOptgroupOrder: true,
            searchField: ['text', 'optgroup'],
            placeholder: 'Pick-up Point *',
            selectOnTab: true
        });
    
        $dropoffLocations.html(listItems);
        $dropoffLocations.selectize({
            onInitialize: function () {
                $fhToSelectize = $($dropoffLocations[0].selectize.$control[0]);
            },
            onFocus: function () {
                _self.searchPanelExpand(curInstance);
            },
            onChange: function (value: any) {
                if ($dropoffLocations.val() != '') {
                    $pickupDateContainers.find('input[name="start"]').focus();
                    $dropoffLocations.parent().find('.selectize-control .selectize-input').removeClass('has-error');
                }
            },
            onBlur: function (data: any) {
            },
            onLoad: function (data: any) {
            },
            lockOptgroupOrder: true,
            searchField: ['text', 'optgroup'],
            placeholder: 'Drop-off Point *',
            selectOnTab: true
        });
    
        $('.pick-up--location').keydown(function (event: any) {
            if (event.keyCode === 9) {
                event.preventDefault();
                event.stopPropagation();
            }
        });
    }
    
	/**
	 * @function searchFormSubmitHandler
	 * !!! Properly scoped
	 */
    searchFormSubmitHandler($instance: any): void {
        let _self = this;
        let curInstance = $instance;
        let $searchSubmitBtn: any = $instance.find('#mholidays-flight-button');
        let $hotelSearchSubmitBtn: any = $instance.find('#mholidays-hotel-button');
        let $tourSearchSubmitBtn: any = $instance.find('#mholidays-tour-button');
        let $transferSearchBtn:any= $instance.find('#mholidays-transfer-button');
        let $deaslsSearchBtn:any= $instance.find('#mholidays-deals-button');
        let $flighthotelSubmitBtn: any = $instance.find('#mholidays-flighthotel-button');

        $searchSubmitBtn.on('click', (evt: any) => {
            evt.preventDefault();
            _self.searchPanelExpand($('.searchFlightHotel'));
            _self.searchFlightHotelSubmit.searchFormValidation(curInstance, '', function($officeCode:any) {
                _self.searchFlightHotelSubmit.mholidaysDeeplinknew($instance);
            });
        });
        $deaslsSearchBtn.on('click', (evt: any) => {
            evt.preventDefault();
            _self.searchPanelExpand($('.searchFlightHotel'));
            _self.searchFlightHotelSubmit.searchFormValidationdeals(curInstance, '', function($officeCode:any) {
                _self.searchFlightHotelSubmit.mholidaysDeeplinkdeals($('#flightHotel_deals'));
            });
        });
        $hotelSearchSubmitBtn.on('click', (evt: any) => {
            evt.preventDefault();
            _self.searchPanelExpand($('#hotel'));
            _self.searchFlightHotelSubmit.hotelSearchFormValidation(curInstance, '', function($officeCode:any) {
                _self.searchFlightHotelSubmit.mholidaysHotelDeeplink($instance);
            });
        });
        $tourSearchSubmitBtn.on('click', (evt: any) => {
            evt.preventDefault();
            _self.searchPanelExpand($('#transfer'));
            _self.searchFlightHotelSubmit.toursearchFormValidation(curInstance, '', function($officeCode:any) {
                _self.searchFlightHotelSubmit.tourDeeplink($instance);
            });
        });
        $transferSearchBtn.on('click', (evt: any) => {
            evt.preventDefault();
            _self.searchPanelExpand($('#transfer'));
            _self.searchFlightHotelSubmit.transfersearchFormValidation(curInstance, '', function($officeCode:any) {
                _self.searchFlightHotelSubmit.transferDeeplink($instance);
            });
        });
        /* flight + hotel PDP */
        $flighthotelSubmitBtn.on('click',(evt: any) => {
            evt.preventDefault();
            _self.searchPanelExpand($('flightHotel2'));
            _self.searchFlightHotelSubmit.searchFormValidationflightHotel(curInstance, '', function($officeCode: any){
                _self.searchFlightHotelSubmit.mholidaysDeeplinkflighthotel($instance);
            });
        });

    }

    /**
	 * @function calendarComponent
	 * Calendar component for flight search
	 * !!! Properly scoped
	 */
    inittransferCalendar(): void {
        let _self = this;
        let nowDate: any = new Date();
        let today: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate(), 0, 0, 0, 0);
        let $ibeMHHMindays: any = $('[data-mhh-min-days]').length > 0 ? parseInt($('[data-mhh-min-days]').attr('data-mhh-min-days')) : 7;
        let tomorrow: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + $ibeMHHMindays, 0, 0, 0, 0);
        let depRange: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + 184, 0, 0, 0, 0);
        let retRange: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + 14, 0, 0, 0, 0);
        let maxLimitDate: any = new Date(nowDate.getFullYear() + 1, nowDate.getMonth(), nowDate.getDate(), 0, 0, 0, 0);

        function highlightDays(date: any) {
            var startDate = new Date($("#searchFlightDepart").datepicker("getDate"));
            var endDate = new Date($("#searchFlightReturn").datepicker("getDate"));

            if ((startDate <= date) && (date <= endDate)) {
                return [true, 'highlight'];
            } else {
                return [true, ''];
            }
        }

        let $dateFormat: any = 'd M yy',
            $departDate = _self.$scope.find('.departuretransferDate')
                .datepicker({
                    showButtonPanel: true,
                    minDate: tomorrow,
                    closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
                    dateFormat: 'd M yy',
                    numberOfMonths:  1,
                    maxDate: depRange,
                    onClose: function(selectedDate: any) {
                        var selectedDatetransfer=$('.departuretransferDate').val().substring(0, 11);
                        let nextDay:any = new Date(selectedDatetransfer);
                        let depDate:any;
                        $('.departuretransferDate').removeClass('active');
                        nextDay.setDate(nextDay.getDate() + 1);
                        if ($('#transfer').css('display') == 'block') {
                            depRange = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#transfer .departuretransferDate').attr('data-datepicker-days')), 0, 0, 0, 0);                            
                            $('#transfer .returntransferDate').datepicker("option", "minDate", ((selectedDatetransfer && selectedDatetransfer!='') ? nextDay : tomorrow));
                            depDate = getDate($('#transfer .departuretransferDate')[0]);
                        }
                        else {
                            depRange = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#flightHotel .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
                            $('#flightHotel .returnDate').datepicker("option", "minDate", ((selectedDatetransfer && selectedDatetransfer!='') ? nextDay : tomorrow));
                            depDate = getDate( $('#flightHotel .departureDate')[0]);
                        }  
                        depDate = depDate ? depDate : nowDate;                                                 
                        if(selectedDatetransfer=='') {
                            $('.returntransferDate').datepicker('option', 'maxDate', depRange);
                        } else {
                            if ($('#transfer').css('display') == 'block') {
                                let $ibeMHHTransferReturDateInterveldays: any = $('[data-transfer-returDate-intervel]').length > 0 ? parseInt($('[data-transfer-returDate-intervel]').attr('data-transfer-returDate-intervel')) : 14;
                                $('#transfer .returntransferDate').datepicker('option', 'maxDate', new Date(depDate.getFullYear(), depDate.getMonth(), depDate.getDate() + $ibeMHHTransferReturDateInterveldays, 0, 0, 0, 0));
                            }
                            else {
                                let $ibeMHHFlightHotelReturDateInterveldays: any = $('[data-flighthotel-returDate-intervel]').length > 0 ? parseInt($('[data-flighthotel-returDate-intervel]').attr('data-flighthotel-returDate-intervel')) : 14;                                
                                $('#flightHotel .returnDate').datepicker('option', 'maxDate', new Date(depDate.getFullYear(), depDate.getMonth(), depDate.getDate() + $ibeMHHFlightHotelReturDateInterveldays, 0, 0, 0, 0));
                            }
                        }
                        $('.returntransferDate').focus();
                    },
                    onSelect: function (selectedDate: any) {
                        var date = $(this).val();
                        var time1= $('.timepicker_depart .hour').val();
                        var time2= $('.timepicker_depart .minute').val();
                        var time3= $('.timepicker_depart .meridiem').val();
                        $('.departuretransferDate').val(date+" "+time1+":"+time2+time3);

                    },
                    beforeShow: function () {                
                        setTimeout(function () {
                            $('.timepicker_depart').remove();
                            $('.departuretransferDate').addClass('active');
                            $('.ui-datepicker-buttonpane').addClass('close_transfer')
                            var hourvalue=$(".timepicker .hour").val();    
                            var minute=$(".timepicker .minute").val();    
                            var meridiem=$(".timepicker .meridiem").val();   
                            $('.ui-datepicker').append('<div class="timepicker_depart" style="text-align:center;cursor: all-scroll "> <select class="hour"></select><span class="colon">:</span><select class="minute"></select><select class="meridiem" ></select></div>');
                            var select = '';
                            for (let i=1;i<=12;i++){
                                select += '<option val=' + i + '>' + i + '</option>';
                            }
                            $('.timepicker_depart .hour').html(select);

                            var select = '';
                            select += '<option value="00">00</option><option value="01">01</option><option value="02">02</option><option value="03">03</option><option value="04">04</option><option value="06">06</option><option value="07">07</option><option value="08">08</option><option value="09">09</option>';
                            for (let i=10;i<=60;i++){
                                select += '<option val=' + i + '>' + i + '</option>';
                            }
                            $('.timepicker_depart .minute').html(select);

                            var select = '';
                            select += '<option value="AM">AM</option><option value="PM">PM</option>';
                            $('.timepicker_depart .meridiem').html(select);

                            $(".timepicker_depart .hour").val(hourvalue);    
                            $(".timepicker_depart .minute").val(minute);    
                            $(".timepicker_depart .meridiem").val(meridiem);   
                        }, 0);
                    }
                })
                .on('change', function () {
                    //$returnDate.datepicker('option', 'minDate', getDate(this));
                    $returnDate.datepicker('setDate', null);
                    let $nextReturnDate: any = $('.returntransferDate');
                    if ($nextReturnDate.val() === "") {
                        window.setTimeout($.proxy(function () {
                            $nextReturnDate.focus();
                        }, this), 100);
                    }
                    if($('.departuretransferDate').val()!='') {
                        $('.departuretransferDate').removeClass('has-empty-error');
                    }
                }),
            $returnDate = _self.$scope.find('.returntransferDate')
                .datepicker({
                    showButtonPanel: true,
                    minDate: tomorrow,
                    closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
                    dateFormat: 'd M yy',
                    numberOfMonths:  1,
                    maxDate: depRange,
                    beforeShow: function () {                
                        setTimeout(function () {
                            $('.timepicker_return').remove();
                            $('.ui-datepicker-buttonpane').addClass('close_transfer')
                            var hourvalue=$(".timepicker_ret .hour").val();    
                            var minute=$(".timepicker_ret .minute").val();    
                            var meridiem=$(".timepicker_ret .meridiem").val();   
                            $('.ui-datepicker').append('<div class="timepicker_return" style="text-align:center;cursor: all-scroll "> <select class="hour"></select><span class="colon">:</span><select class="minute"></select><select class="meridiem" ></select></div>');
                            var select = '';
                            for (let i=1;i<=12;i++){
                                select += '<option val=' + i + '>' + i + '</option>';
                            }
                            $('.timepicker_return .hour').html(select);

                            var select = '';
                            select += '<option value="00">00</option><option value="01">01</option><option value="02">02</option><option value="03">03</option><option value="04">04</option><option value="06">06</option><option value="07">07</option><option value="08">08</option><option value="09">09</option>';
                            for (let i=10;i<=60;i++){
                                select += '<option val=' + i + '>' + i + '</option>';
                            }
                            $('.timepicker_return .minute').html(select);

                            var select = '';
                            select += '<option value="AM">AM</option><option value="PM">PM</option>';
                            $('.timepicker_return .meridiem').html(select);

                            $(".timepicker_return .hour").val(hourvalue);    
                            $(".timepicker_return .minute").val(minute);    
                            $(".timepicker_return .meridiem").val(meridiem);   
                        }, 0);
                    },
                    onSelect: function (selectedDate: any) {
                        var date = $(this).val();
                        var time1= $('.timepicker_return .hour').val();
                        var time2= $('.timepicker_return .minute').val();
                        var time3= $('.timepicker_return .meridiem').val();
                        $('.returntransferDate').val(date+" "+time1+":"+time2+time3);
                        $('#transfer .passenger-details-selected').show();

                    }
                })
                .on('change', function () {
                    if($('.returntransferDate').val()!='') {
                        $('.returntransferDate').removeClass('has-empty-error');
                    }
                    $('#transfer .passenger-details-selected').show();
                });

        let getDate:any = ($element: any) => {
            let $getDate: any;
            try {
                $getDate = $.datepicker.parseDate($dateFormat, $element.value);
            } catch (error) {
                $getDate = null;
            }
            return $getDate;
        }
        let depRangeHotel: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#transfer .departuretransferDate').attr('data-datepicker-days')), 0, 0, 0, 0);
        $('#transfer .departuretransferDate').datepicker('option', 'maxDate', depRangeHotel);
        $('#transfer .returntransferDate').datepicker('option', 'maxDate', depRangeHotel);
    }
    initCalendar(): void {
        let _self = this;
        let nowDate: any = new Date();
        let today: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate(), 0, 0, 0, 0);
        let $ibeMHHMindays: any = $('[data-mhh-min-days]').length > 0 ? parseInt($('[data-mhh-min-days]').attr('data-mhh-min-days')) : 7;
        let tomorrow: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + $ibeMHHMindays, 0, 0, 0, 0);
        let depRange: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + 184, 0, 0, 0, 0);
        let retRange: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + 14, 0, 0, 0, 0);
        let maxLimitDate: any = new Date(nowDate.getFullYear() + 1, nowDate.getMonth(), nowDate.getDate(), 0, 0, 0, 0);

        let $curDatepickerInst:any;
        let $curDatepickerTitle: any;

        function highlightDays(date: any) {
            var startDate = new Date($("#searchFlightDepart").datepicker("getDate"));
            var endDate = new Date($("#searchFlightReturn").datepicker("getDate"));

            if ((startDate <= date) && (date <= endDate)) {
                return [true, 'highlight'];
            } else {
                return [true, ''];
            }
        }
        let $dateFormat: any = 'd M yy',
            $departDate = _self.$scope.find('.departureDate')
            
                .datepicker({
                    showButtonPanel: true,
                    minDate: tomorrow,
                    closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
                    dateFormat: 'd M yy',
                    numberOfMonths:  2,
                    maxDate: depRange,
                    onClose: function(selectedDate: any) {
                        let nextDay:any = new Date(selectedDate);
                        let depDate:any;
                        nextDay.setDate(nextDay.getDate() + 1);
                        if ($('#hotel').css('display') == 'block') {
                            depRange = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#hotel .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);                            
                            $('#hotel .returnDate').datepicker("option", "minDate", ((selectedDate && selectedDate!='') ? nextDay : tomorrow));
                            depDate = getDate($('#hotel .departureDate')[0]);
                        }
                        else if ($('#tour').css('display') == 'block') {
                            depRange = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#tour .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);                            
                            $('#tour .returnDate').datepicker("option", "minDate", ((selectedDate && selectedDate!='') ? nextDay : tomorrow));
                            depDate = getDate($('#tour .departureDate')[0]);
                        }
                        else if ($('#flightHotel_deals').css('display') == 'block'){
                            depRange = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#flightHotel_deals .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
                            $('#flightHotel_deals .returnDate').datepicker("option", "minDate", ((selectedDate && selectedDate!='') ? nextDay : tomorrow));
                            depDate = getDate( $('#flightHotel_deals .departureDate')[0]);
                        }
                        else if ($('#flightHotel2').css('display') == 'block') {
                            depRange = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#flightHotel2 .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
                            $('#flightHotel2 .returnDate').datepicker("option", "minDate", ((selectedDate && selectedDate!='') ? nextDay : tomorrow));
                            depDate = getDate( $('#flightHotel2 .departureDate')[0]);
                        }                          
                        else {
                            depRange = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#flightHotel .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
                            $('#flightHotel .returnDate').datepicker("option", "minDate", ((selectedDate && selectedDate!='') ? nextDay : tomorrow));
                            depDate = getDate( $('#flightHotel .departureDate')[0]);
                        }  
                        depDate = depDate ? depDate : nowDate;                                                 
                        if(selectedDate=='') {
                            $('.returnDate').datepicker('option', 'maxDate', depRange);
                        } else {
                            if ($('#hotel').css('display') == 'block') {
                                let $ibeMHHotelReturDateInterveldays: any = $('[data-hotel-returDate-intervel]').length > 0 ? parseInt($('[data-hotel-returDate-intervel]').attr('data-hotel-returDate-intervel')) : 14;
                                $('#hotel .returnDate').datepicker('option', 'maxDate', new Date(depDate.getFullYear(), depDate.getMonth(), depDate.getDate() + $ibeMHHotelReturDateInterveldays, 0, 0, 0, 0));
                            }
                            else if ($('#tour').css('display') == 'block') {
                                let $ibeMHTourReturDateInterveldays: any = $('[data-tour-returDate-intervel]').length > 0 ? parseInt($('[data-tour-returDate-intervel]').attr('data-tour-returDate-intervel')) : 14;                                
                                $('#tour .returnDate').datepicker('option', 'maxDate', new Date(depDate.getFullYear(), depDate.getMonth(), depDate.getDate() + $ibeMHTourReturDateInterveldays, 0, 0, 0, 0));
                            }
                            else if ($('#flightHotel_deals').css('display') == 'block') {
                                let $ibeMHFamilyOfferReturDateInterveldays: any = $('[data-familyOffer-returDate-intervel]').length > 0 ? parseInt($('[data-familyOffer-returDate-intervel]').attr('data-familyOffer-returDate-intervel')) : 14;  
                                $('#flightHotel_deals .returnDate').datepicker('option', 'maxDate', new Date(depDate.getFullYear(), depDate.getMonth(), depDate.getDate() + $ibeMHFamilyOfferReturDateInterveldays, 0, 0, 0, 0));
                            }
                            else if ($('#flightHotel2').css('display') == 'block') {
                                let $ibeMHFamilyOfferReturDateInterveldays: any = $('[data-familyOffer-returDate-intervel]').length > 0 ? parseInt($('[data-familyOffer-returDate-intervel]').attr('data-familyOffer-returDate-intervel')) : 14;  
                                $('#flightHotel2 .returnDate').datepicker('option', 'maxDate', new Date(depDate.getFullYear(), depDate.getMonth(), depDate.getDate() + $ibeMHFamilyOfferReturDateInterveldays, 0, 0, 0, 0));
                            }
                            else {
                                let $ibeMHFlightHotelReturDateInterveldays: any = $('[data-flighthotel-returDate-intervel]').length > 0 ? parseInt($('[data-flighthotel-returDate-intervel]').attr('data-flighthotel-returDate-intervel')) : 14;
                                $('#flightHotel .returnDate').datepicker('option', 'maxDate', new Date(depDate.getFullYear(), depDate.getMonth(), depDate.getDate() + $ibeMHFlightHotelReturDateInterveldays, 0, 0, 0, 0));
                            }
                        }
                    },
                    beforeShow: function(ele:any, obj:any) {
                        // if($('.ibe-refresh').length >0) {
                        //     $('#ui-datepicker-div').addClass('ibe-refresh-datepicker');
                        // }
                        
                        let $from_field: any;
                        let $currentTab:any;
                        if ($('#flightHotel2').css('display') == 'block') {
                            $from_field = $("#flightHotel2 .departureDate");
                            $currentTab = $('#flightHotel2');
                        }
                        else if ($('#flightHotel_deals').css('display') == 'block'){
                            $from_field = $("#flightHotel_deals .departureDate");
                            $currentTab = $('#flightHotel_deals');
                        }
                        else if ($('#flightHotel').css('display') == 'block'){
                            $from_field = $("#flightHotel .departureDate");
                            $currentTab = $('#flightHotel');
                        }
                        else {
                            return;
                        }

                        $curDatepickerInst  = obj.dpDiv[0];
                        $curDatepickerTitle = ele.dataset.datepickerTitle;
                        let $lowfareFrom:any = $currentTab.find('[name="fhFromLocation"]').val();
                        let $lowfareTo:any = $currentTab.find('[name="fhToLocation"]').val().split('-')[1];
                        let $lowfareDate:any = $from_field.val();
                        var dateObj = new Date($lowfareDate);
                        var momentObj = moment(dateObj);
                        var momentString = momentObj.format('DDMMYY');
                        setTimeout(function () {
                            _self.bcommon.lowfareApiMholiday($lowfareFrom,$lowfareTo,momentString);
                            }, 500);
                    },
                    onChangeMonthYear: function(month:any, year:any, dp:any) {
                        //only for lowfare API  - not for hotel/tour/travel datepickers
                        if ($('#flightHotel2').css('display') !== 'block' &&
                        $('#flightHotel_deals').css('display') !== 'block' &&
                        $('#flightHotel').css('display') !== 'block') {
                            return;
                        }
                        _self.bcommon.lowfareApiMholiday();
                    }
                })
                .on('change', function () {
                    //$returnDate.datepicker('option', 'minDate', getDate(this));
                    $returnDate.datepicker('setDate', null);
                    let $nextReturnDate: any = $(this).parents(".tab-pane").find('.returnDate');
                    if ($nextReturnDate.val() === "") {
                        window.setTimeout($.proxy(function () {
                            $nextReturnDate.focus();
                        }, this), 100);
                    }
                    if($('.departureDate').val()!='') {
                        $('.departureDate').removeClass('has-empty-error');
                    }
                }),
            $returnDate = _self.$scope.find('.returnDate')
                .datepicker({
                    showButtonPanel: true,
                    minDate: tomorrow,
                    closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
                    dateFormat: 'd M yy',
                    numberOfMonths:  2,
                    maxDate: depRange
                })
                .on('change', function () {
                    if($('.returnDate').val()!='') {
                        $('.returnDate').removeClass('has-empty-error');
                    }
                    $('.passenger-details-selected').show();
                });

        let getDate:any = ($element: any) => {
            let $getDate: any;
            try {
                $getDate = $.datepicker.parseDate($dateFormat, $element.value);
            } catch (error) {
                $getDate = null;
            }
            return $getDate;
        }
        let depRangeFlight: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#flightHotel .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
        let depRangeHotel: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#hotel .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
        let depRangeFlightHotel2: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#flightHotel2 .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
        let depRangeTours: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#tour .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
        let depRangeFamilyOffers: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#flightHotel_deals .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
        $('#hotel .departureDate').datepicker('option', 'maxDate', depRangeHotel);
        $('#hotel .returnDate').datepicker('option', 'maxDate', depRangeHotel);
        $('#flightHotel .departureDate').datepicker('option', 'maxDate', depRangeFlight);
        $('#flightHotel .returnDate').datepicker('option', 'maxDate', depRangeFlight);
        $('#flightHotel2 .departureDate').datepicker('option', 'maxDate', depRangeFlightHotel2);
        $('#flightHotel2 .returnDate').datepicker('option', 'maxDate', depRangeFlightHotel2);
        $('#tour .departureDate').datepicker('option', 'maxDate', depRangeTours);
        $('#tour .returnDate').datepicker('option', 'maxDate', depRangeTours);
        $('#flightHotel_deals .departureDate').datepicker('option', 'maxDate', depRangeFamilyOffers);
        $('#flightHotel_deals .returnDate').datepicker('option', 'maxDate', depRangeFamilyOffers);
    }
    inputFormFocus(): void {
		$('.form-validate')
		.off('focus', 'input')
		.on('focus','input',function() {
			let $input:any = $(this);
			// trigger focus state
			$input.addClass('input-focused');
			$('.booking-form--title',$input.parent()).addClass('input-filled');
			$('.date-form--title',$input.parent()).addClass('input-filled');

			// clear errors on focus
			$input.parent().removeClass('has-error');
			$('.booking-form--title',$input.parent()).removeClass('has-error');
			$('.date-form--title',$input.parent()).removeClass('has-error');
		})
		.off('blur', 'input')
		.on('blur','input',function() {
			let $input:any = $(this);
			if ($input.val() == '') {
				// trigger empty state
				$input.removeClass('input-focused');
				$('.booking-form--title',$input.parent()).removeClass('input-filled');
			}
			else {
				// trigger focused state
				$input.addClass('input-focused');
				$('.booking-form--title',$input.parent()).addClass('input-filled');
				$('.date-form--title',$input.parent()).addClass('input-filled');
			}
		})
		.off('click','.booking-form--title')
		.on('click','.booking-form--title',function() {
			let $label:any = $(this);
			$label.addClass('input-filled');
			$('input',$label.parent()).addClass('input-focused').focus();
		})

		// handle initial states on load
		$('.form-validate input').each(function(){
			let $input:any = $(this);
			if ($input.val() == '') {
				// trigger empty state
				$input.removeClass('input-focused');
				$('.booking-form--title',$input.parent()).removeClass('input-filled');
				$('.date-form--title',$input.parent()).removeClass('input-filled');
			}
			else {
				// trigger focused state
				$input.addClass('input-focused');
				$('.booking-form--title',$input.parent()).addClass('input-filled');
				$('.date-form--title',$input.parent()).addClass('input-filled');
			}
		});
    }
    
    timesetings(): void {
 
        $(document).on('click','.ui-datepicker-header',function(evt:any)
        {
            if($("ul li.active a")[0].innerText=="Transfer")
            {
            if($('.departuretransferDate').hasClass('active'))
            {
                    $('.timepicker_depart').remove();
                    $('.ui-datepicker-buttonpane').addClass('close_transfer')
                    var hourvalue=$(".timepicker .hour").val();    
                    var minute=$(".timepicker .minute").val();    
                    var meridiem=$(".timepicker .meridiem").val();   
                    $('.ui-datepicker').append('<div class="timepicker_depart" style="text-align:center; cursor: all-scroll "> <select class="hour"></select><span class="colon">:</span><select class="minute"></select><select class="meridiem" ></select></div>');
                    var select = '';
                    for (let i=1;i<=12;i++){
                        select += '<option val=' + i + '>' + i + '</option>';
                    }
                    $('.timepicker_depart .hour').html(select);

                    var select = '';
                    select += '<option value="00">00</option><option value="01">01</option><option value="02">02</option><option value="03">03</option><option value="04">04</option><option value="06">06</option><option value="07">07</option><option value="08">08</option><option value="09">09</option>';
                    for (let i=10;i<=60;i++){
                        select += '<option val=' + i + '>' + i + '</option>';
                    }
                    $('.timepicker_depart .minute').html(select);

                    var select = '';
                    select += '<option value="AM">AM</option><option value="PM">PM</option>';
                    $('.timepicker_depart .meridiem').html(select);
                    $(".timepicker_depart .hour").val(hourvalue);    
                    $(".timepicker_depart .minute").val(minute);    
                    $(".timepicker_depart .meridiem").val(meridiem);   
            }
            else
            {
                $('.timepicker_return').remove();
                $('.ui-datepicker-buttonpane').addClass('close_transfer')
                var hourvalue=$(".timepicker_ret .hour").val();    
                var minute=$(".timepicker_ret .minute").val();    
                var meridiem=$(".timepicker_ret .meridiem").val();   
                $('.ui-datepicker').append('<div class="timepicker_return" style="text-align:center; cursor: all-scroll "> <select class="hour"></select><span class="colon">:</span><select class="minute"></select><select class="meridiem" ></select></div>');
                var select = '';
                for (let i=1;i<=12;i++){
                    select += '<option val=' + i + '>' + i + '</option>';
                }
                $('.timepicker_return .hour').html(select);

                var select = '';
                select += '<option value="00">00</option><option value="01">01</option><option value="02">02</option><option value="03">03</option><option value="04">04</option><option value="06">06</option><option value="07">07</option><option value="08">08</option><option value="09">09</option>';
                for (let i=10;i<=60;i++){
                    select += '<option val=' + i + '>' + i + '</option>';
                }
                $('.timepicker_return .minute').html(select);

                var select = '';
                select += '<option value="AM">AM</option><option value="PM">PM</option>';
                $('.timepicker_return .meridiem').html(select);
                $(".timepicker_return .hour").val(hourvalue);    
                $(".timepicker_return .minute").val(minute);    
                $(".timepicker_return .meridiem").val(meridiem);   
            }
        }
        });
        $(document).on('change ','.timepicker_depart',function(){
            $(".timepicker .hour").val($(".timepicker_depart .hour").val());    
            $(".timepicker .minute").val($(".timepicker_depart .minute").val());    
            $(".timepicker .meridiem").val($(".timepicker_depart .meridiem").val());  
            var date = $('.departuretransferDate').val().substring(0, 11);
            var time1= $('.hour').val();
            var time2= $('.minute').val();
            var time3= $('.meridiem').val();
            $('.departuretransferDate').val(date+" "+time1+":"+time2+time3);

        }); 
        $(document).on('change ','.timepicker_return',function(){
            $(".timepicker_ret .hour").val($(".timepicker_return .hour").val());    
            $(".timepicker_ret .minute").val($(".timepicker_return .minute").val());    
            $(".timepicker_ret .meridiem").val($(".timepicker_return .meridiem").val());  
            var date = $('.departuretransferDate').val().substring(0, 11);
            var time1= $('.timepicker_return .hour').val();
            var time2= $('.timepicker_return .minute').val();
            var time3= $('.timepicker_return .meridiem').val();
            $('.returntransferDate').val(date+" "+time1+":"+time2+time3);

        });
        }
        travelrvalidation_flight()
        {
            var select = '';
            select += '<option value="1" selected="selected">1 adult</option>'
            for (let i=2;i<=9;i++)
            {
                    select += '<option value=' + i + '>' + i +' adult'+ '</option>';
            }
            $('.trv-info .val_onchange').html(select);
    
            var select = '';
            select += '<option value="0" selected="selected">0 child/teenager</option>'
            for (let i=1;i<=6;i++)
            {
                    select += '<option value=' + i + '>' + i +' child/teenager'+ '</option>';
            }
            $('.trv-info .val_onchangechild').html(select);
    
            var select = '';
            select += '<option value="0" selected="selected">0 infant</option>'
            for (let i=1;i<=3;i++)
            {
                    select += '<option value=' + i + '>' + i +' infant'+ '</option>';
            }
            $('.trv-info .val_onchangeinfant').html(select);
        
            $(".val_onchange").click(function()
            {
                var room1_adults=0;
                var room1_child=0;
                var room2_adults=0;
                var room2_child=0;
                var room3_adults=0;
                var room3_child=0
                room1_adults =  parseInt($("#room1_adults_count").val()) ||0;
                room1_child =  parseInt($("#room1_child_count").val()) ||0;
                if(!$('#flightHotel .room_two').hasClass('hide'))
                {
                     room2_adults =  parseInt($("#room2_adults_count").val());
                    room2_child =  parseInt($("#room2_child_count").val()); 
                }
                if(!$('#flightHotel .room_three').hasClass('hide'))
                {
                    room3_adults =  parseInt($("#room3_adults_count").val());
                    room3_child =  parseInt($("#room3_child_count").val());
                }
                if(this.id=="room1_adults_count")
                {
                    var totalcount=room1_child+room2_adults+room2_child+room3_adults+room3_child;
                    var select_adult = '';
                    for (let i=1;i<=(9-totalcount);i++)
                    {
                        if(i==room1_adults)
                        {
                            select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                        }
                        else
                        {
                            select_adult += '<option value=' + i +'>' + i +' adult'+ '</option>';
                        }
                    }
        
                    for (let i=(10-totalcount);i<=(9);i++)
                    {
                        if(i==room1_adults)
                        {
                            select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                        }
                        {
                            select_adult += '<option value=' + i + ' + disabled="disabled">' + i +' adult'+ '</option>';
                        }
                    }
        
                    $('#room1_adults_count').html(select_adult);
    
                }
                if(this.id=="room2_adults_count")
                {
                    var totalcount=room1_child+room1_adults+room2_child+room3_adults+room3_child;
                    var select_adult = '';
                    for (let i=1;i<=(9-totalcount);i++)
                    {
                        if(i==room2_adults)
                        {
                            select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                        }
                        else
                        {
                            select_adult += '<option value=' + i +'>' + i +' adult'+ '</option>';
                        }
                    }
        
                    for (let i=(10-totalcount);i<=(9);i++)
                    {
                        if(i==room2_adults)
                        {
                            select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                        }
                        {
                            select_adult += '<option value=' + i + ' + disabled="disabled">' + i +' adult'+ '</option>';
                        }
                    }
        
                    $('#room2_adults_count').html(select_adult);
    
                }
                if(this.id=="room3_adults_count")
                {
                    var totalcount=room1_child+room2_adults+room2_child+room1_adults+room3_child;
                    var select_adult = '';
                    for (let i=1;i<=(9-totalcount);i++)
                    {
                        if(i==room3_adults)
                        {
                            select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                        }
                        else
                        {
                            select_adult += '<option value=' + i +'>' + i +' adult'+ '</option>';
                        }
                    }
        
                    for (let i=(10-totalcount);i<=(9);i++)
                    {
                        if(i==room3_adults)
                        {
                            select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                        }
                        {
                            select_adult += '<option value=' + i + ' + disabled="disabled">' + i +' adult'+ '</option>';
                        }
                    }
        
                    $('#room3_adults_count').html(select_adult);
    
                }
            });
            $(".val_onchangechild").click(function()
            {
                var room1_adults=0;
                var room1_child=0;
                var room2_adults=0;
                var room2_child=0;
                var room3_adults=0;
                var room3_child=0
                room1_adults =  parseInt($("#room1_adults_count").val()) ||0;
                room1_child =  parseInt($("#room1_child_count").val()) ||0;
                if(!$('#flightHotel .room_two').hasClass('hide'))
                {
                     room2_adults =  parseInt($("#room2_adults_count").val());
                    room2_child =  parseInt($("#room2_child_count").val()); 
                }
                if(!$('#flightHotel .room_three').hasClass('hide'))
                {
                    room3_adults =  parseInt($("#room3_adults_count").val());
                    room3_child =  parseInt($("#room3_child_count").val());
                }
                if(this.id=="room1_child_count")
                {
                    var totalcount=room1_adults+room2_adults+room2_child+room3_adults+room3_child;
                    if((9-totalcount)<=6)
                    {
                    var select_child = '';
                    for (let i=0;i<=(9-totalcount);i++)
                    {
                        if(i==room1_child)
                        {
                            select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                        }
                        else
                        {
                            select_child += '<option value=' + i +'>' + i +' child/teenager'+ '</option>';
                        }
                    }
        
                    for (let i=(10-totalcount);i<=(6);i++)
                    {
                        if(i==room1_child)
                        {
                            select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                        }
                        {
                            select_child += '<option value=' + i + ' + disabled="disabled">' + i +' child/teenager'+ '</option>';
                        }
                    }
        
                    $('#room1_child_count').html(select_child);
                }
                }
                if(this.id=="room2_child_count")
                {
                    var totalcount=room1_adults+room2_adults+room1_child+room3_adults+room3_child;
                    if((9-totalcount)<=6)
                    {
                    var select_child = '';
                    for (let i=0;i<=(9-totalcount);i++)
                    {
                        if(i==room2_child)
                        {
                            select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                        }
                        else
                        {
                            select_child += '<option value=' + i +'>' + i +' child/teenager'+ '</option>';
                        }
                    }
        
                    for (let i=(10-totalcount);i<=(6);i++)
                    {
                        if(i==room2_child)
                        {
                            select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                        }
                        {
                            select_child += '<option value=' + i + ' + disabled="disabled">' + i +' child/teenager'+ '</option>';
                        }
                    }
        
                    $('#room2_child_count').html(select_child);
                }
                }
                if(this.id=="room3_child_count")
                {
                    var totalcount=room1_adults+room2_adults+room2_child+room3_adults+room1_child;
                    if((9-totalcount)<=6)
                    {
                    var select_child = '';
                    for (let i=0;i<=(9-totalcount);i++)
                    {
                        if(i==room3_child)
                        {
                            select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                        }
                        else
                        {
                            select_child += '<option value=' + i +'>' + i +' child/teenager'+ '</option>';
                        }
                    }
        
                    for (let i=(10-totalcount);i<=(6);i++)
                    {
                        if(i==room3_child)
                        {
                            select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                        }
                        {
                            select_child += '<option value=' + i + ' + disabled="disabled">' + i +' child/teenager'+ '</option>';
                        }
                    }
        
                    $('#room3_child_count').html(select_child);
                }
                }           
            });
            $(".val_onchangeinfant").click(function()
            {
                var room1_adults =  parseInt($("#room1_adults_count").val()) ||0;
                var room1_infant =  parseInt($("#room1_infants_count").val())||0;
                var room2_adults =  parseInt($("#room2_adults_count").val()) ||0;
                var room2_infant =  parseInt($("#room2_infants_count").val())||0;
                var room3_adults =  parseInt($("#room3_adults_count").val()) ||0;
                var room3_infant =  parseInt($("#room3_infants_count").val())||0;
                if(room1_adults<=3)
                {
                    var select_infant = '';
                    for (let i=0;i<=(room1_adults);i++)
                    {
                        if(i==room1_infant)
                        {
                            select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                        }
                        else
                        {
                            select_infant += '<option value=' + i +'>' + i +' infant'+ '</option>';
                        }
                    }
                    for (let i=(room1_adults+1);i<=(3);i++)
                    {
                        if(i==room1_infant)
                        {
                            select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                        }
                        {
                            select_infant += '<option value=' + i + ' + disabled="disabled">' + i +' infant'+ '</option>';
                        }
                    }
                    $('#room1_infants_count').html(select_infant);
                }
                if(room2_adults<=3)
                {
                    var select_infant = '';
                    for (let i=0;i<=(room2_adults);i++)
                    {
                        if(i==room2_infant)
                        {
                            select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                        }
                        else
                        {
                            select_infant += '<option value=' + i +'>' + i +' infant'+ '</option>';
                        }
                    }
                    for (let i=(room2_adults+1);i<=(3);i++)
                    {
                        if(i==room2_infant)
                        {
                            select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                        }
                        {
                            select_infant += '<option value=' + i + ' + disabled="disabled">' + i +' infant'+ '</option>';
                        }
                    }
                    $('#room2_infants_count').html(select_infant);
                }
                if(room3_adults<=3)
                {
                    var select_infant = '';
                    for (let i=0;i<=(room3_adults);i++)
                    {
                        if(i==room3_infant)
                        {
                            select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                        }
                        else
                        {
                            select_infant += '<option value=' + i +'>' + i +' infant'+ '</option>';
                        }
                    }
                    for (let i=(room3_adults+1);i<=(3);i++)
                    {
                        if(i==room3_infant)
                        {
                            select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                        }
                        {
                            select_infant += '<option value=' + i + ' + disabled="disabled">' + i +' infant'+ '</option>';
                        }
                    }
                    $('#room3_infants_count').html(select_infant);
                }
            });
        }
        travelrvalidation_hotel()
        {
            var select = '';
            select += '<option value="1" selected="selected">1 adult</option>'
            for (let i=2;i<=9;i++)
            {
                    select += '<option value=' + i + '>' + i +' adult'+ '</option>';
            }
            $('.trv-info .val_onchangehotel').html(select);
    
            var select = '';
            select += '<option value="0" selected="selected">0 child/teenager</option>'
            for (let i=1;i<=6;i++)
            {
                    select += '<option value=' + i + '>' + i +' child/teenager'+ '</option>';
            }
            $('.trv-info .val_onchangehotelchild').html(select);
    
            var select = '';
            select += '<option value="0" selected="selected">0 infant</option>'
            for (let i=1;i<=3;i++)
            {
                    select += '<option value=' + i + '>' + i +' infant'+ '</option>';
            }
            $('.trv-info .val_onchangehotelinfant').html(select);
            
                $(".val_onchangehotel").click(function()
                {
                    var room1_adults_hotel=0;
                    var room1_child_hotel=0;
                    var room2_adults_hotel=0;
                    var room2_child_hotel=0;
                    var room3_adults_hotel=0;
                    var room3_child_hotel=0
                    room1_adults_hotel =  parseInt($("#room1_adults_count_hotel").val()) ||0;
                    room1_child_hotel =  parseInt($("#room1_child_count_hotel").val()) ||0;
                    if(!$('#hotel .room_two').hasClass('hide'))
                    {
                         room2_adults_hotel =  parseInt($("#room2_adults_count_hotel").val());
                        room2_child_hotel =  parseInt($("#room2_child_count_hotel").val()); 
                    }
                    if(!$('#hotel .room_three').hasClass('hide'))
                    {
                        room3_adults_hotel =  parseInt($("#room3_adults_count_hotel").val());
                        room3_child_hotel =  parseInt($("#room3_child_count_hotel").val());
                    }

                    if(this.id=="room1_adults_count_hotel")
                    {
                        var totalcount=room1_child_hotel;
                        var select_adult = '';
                        for (let i=1;i<=(9-room1_child_hotel);i++)
                        {
                            if(i==room1_adults_hotel)
                            {
                                select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                            }
                            else
                            {
                                select_adult += '<option value=' + i +'>' + i +' adult'+ '</option>';
                            }
                        }
            
                        for (let i=(10-room1_child_hotel);i<=(9);i++)
                        {
                            if(i==room1_adults_hotel)
                            {
                                select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                            }
                            {
                                select_adult += '<option value=' + i + ' + disabled="disabled">' + i +' adult'+ '</option>';
                            }
                        }
            
                        $('#room1_adults_count_hotel').html(select_adult);
        
                    }
                    if(this.id=="room2_adults_count_hotel")
                    {
                        var select_adult = '';
                        for (let i=1;i<=(9-room2_child_hotel);i++)
                        {
                            if(i==room2_adults_hotel)
                            {
                                select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                            }
                            else
                            {
                                select_adult += '<option value=' + i +'>' + i +' adult'+ '</option>';
                            }
                        }
            
                        for (let i=(10-room2_child_hotel);i<=(9);i++)
                        {
                            if(i==room2_adults_hotel)
                            {
                                select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                            }
                            {
                                select_adult += '<option value=' + i + ' + disabled="disabled">' + i +' adult'+ '</option>';
                            }
                        }
            
                        $('#room2_adults_count_hotel').html(select_adult);
        
                    }
                    if(this.id=="room3_adults_count_hotel")
                    {
                        var select_adult = '';
                        for (let i=1;i<=(9-room3_child_hotel);i++)
                        {
                            if(i==room3_adults_hotel)
                            {
                                select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                            }
                            else
                            {
                                select_adult += '<option value=' + i +'>' + i +' adult'+ '</option>';
                            }
                        }
            
                        for (let i=(10-room3_child_hotel);i<=(9);i++)
                        {
                            if(i==room3_adults_hotel)
                            {
                                select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                            }
                            else
                            {
                                select_adult += '<option value=' + i + ' + disabled="disabled">' + i +' adult'+ '</option>';
                            }
                        }
            
                        $('#room3_adults_count_hotel').html(select_adult);
        
                    }
                });
                $(".val_onchangehotelinfant").click(function()
                {
                    var room1_adults =  parseInt($("#room1_adults_count_hotel").val()) ||0;
                    var room1_infant =  parseInt($("#room1_infants_count_hotel").val())||0;
                    var room2_adults =  parseInt($("#room2_adults_count_hotel").val()) ||0;
                    var room2_infant =  parseInt($("#room2_infants_count_hotel").val())||0;
                    var room3_adults =  parseInt($("#room3_adults_count_hotel").val()) ||0;
                    var room3_infant =  parseInt($("#room3_infants_count_hotel").val())||0;
                    if(room1_adults<=3)
                    {
                        var select_infant = '';
                        for (let i=0;i<=(room1_adults);i++)
                        {
                            if(i==room1_infant)
                            {
                                select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                            }
                            else
                            {
                                select_infant += '<option value=' + i +'>' + i +' infant'+ '</option>';
                            }
                        }
                        for (let i=(room1_adults+1);i<=(3);i++)
                        {
                            if(i==room1_infant)
                            {
                                select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                            }
                            {
                                select_infant += '<option value=' + i + ' + disabled="disabled">' + i +' infant'+ '</option>';
                            }
                        }
                        $('#room1_infants_count_hotel').html(select_infant);
                    }
                    if(room2_adults<=3)
                    {
                        var select_infant = '';
                        for (let i=0;i<=(room2_adults);i++)
                        {
                            if(i==room2_infant)
                            {
                                select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                            }
                            else
                            {
                                select_infant += '<option value=' + i +'>' + i +' infant'+ '</option>';
                            }
                        }
                        for (let i=(room2_adults+1);i<=(3);i++)
                        {
                            if(i==room2_infant)
                            {
                                select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                            }
                            {
                                select_infant += '<option value=' + i + ' + disabled="disabled">' + i +' infant'+ '</option>';
                            }
                        }
                        $('#room2_infants_count_hotel').html(select_infant);
                    }
                    if(room3_adults<=3)
                    {
                        var select_infant = '';
                        for (let i=0;i<=(room3_adults);i++)
                        {
                            if(i==room3_infant)
                            {
                                select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                            }
                            else
                            {
                                select_infant += '<option value=' + i +'>' + i +' infant'+ '</option>';
                            }
                        }
                        for (let i=(room3_adults+1);i<=(3);i++)
                        {
                            if(i==room3_infant)
                            {
                                select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                            }
                            {
                                select_infant += '<option value=' + i + ' + disabled="disabled">' + i +' infant'+ '</option>';
                            }
                        }
                        $('#room3_infants_count_hotel').html(select_infant);
                    }
                });
                $(".val_onchangehotelchild").click(function()
                {
                    var room1_adults=0;
                    var room1_child=0;
                    var room2_adults=0;
                    var room2_child=0;
                    var room3_adults=0;
                    var room3_child=0
                    room1_adults =  parseInt($("#room1_adults_count_hotel").val()) ||0;
                    room1_child =  parseInt($("#room1_child_count_hotel").val()) ||0;
                    if(!$('#hotel .room_two').hasClass('hide'))
                    {
                         room2_adults =  parseInt($("#room2_adults_count_hotel").val());
                        room2_child =  parseInt($("#room2_child_count_hotel").val()); 
                    }
                    if(!$('#hotel .room_three').hasClass('hide'))
                    {
                        room3_adults =  parseInt($("#room3_adults_count_hotel").val());
                        room3_child =  parseInt($("#room3_child_count_hotel").val());
                    }
                    if(this.id=="room1_child_count_hotel")
                    {
                        var totalcount=room1_adults;
                        if((9-totalcount)<=6)
                        {
                        var select_child = '';
                        for (let i=0;i<=(9-totalcount);i++)
                        {
                            if(i==room1_child)
                            {
                                select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                            }
                            else
                            {
                                select_child += '<option value=' + i +'>' + i +' child/teenager'+ '</option>';
                            }
                        }
            
                        for (let i=(10-totalcount);i<=(6);i++)
                        {
                            if(i==room1_child)
                            {
                                select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                            }
                            {
                                select_child += '<option value=' + i + ' + disabled="disabled">' + i +' child/teenager'+ '</option>';
                            }
                        }
            
                        $('#room1_child_count_hotel').html(select_child);
                    }
                }
                if(this.id=="room2_child_count_hotel")
                {
                    var totalcount=room2_adults;
                    if((9-totalcount)<=6)
                    {
                    var select_child = '';
                    for (let i=0;i<=(9-totalcount);i++)
                    {
                        if(i==room1_child)
                        {
                            select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                        }
                        else
                        {
                            select_child += '<option value=' + i +'>' + i +' child/teenager'+ '</option>';
                        }
                    }
        
                    for (let i=(10-totalcount);i<=(6);i++)
                    {
                        if(i==room1_child)
                        {
                            select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                        }
                        {
                            select_child += '<option value=' + i + ' + disabled="disabled">' + i +' child/teenager'+ '</option>';
                        }
                    }
        
                    $('#room2_child_count_hotel').html(select_child);
                }
            }
            if(this.id=="room3_child_count_hotel")
            {
                var totalcount=room3_adults;
                if((9-totalcount)<=6)
                {
                var select_child = '';
                for (let i=0;i<=(9-totalcount);i++)
                {
                    if(i==room1_child)
                    {
                        select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                    }
                    else
                    {
                        select_child += '<option value=' + i +'>' + i +' child/teenager'+ '</option>';
                    }
                }
    
                for (let i=(10-totalcount);i<=(6);i++)
                {
                    if(i==room1_child)
                    {
                        select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                    }
                    {
                        select_child += '<option value=' + i + ' + disabled="disabled">' + i +' child/teenager'+ '</option>';
                    }
                }
    
                $('#room3_child_count_hotel').html(select_child);
            }
        }
                });
        }
        travelrvalidation_transfer()
        {
            var select = '';
            select += '<option value="1" selected="selected">1 adult</option>'
            for (let i=2;i<=9;i++)
            {
                    select += '<option value=' + i + '>' + i +' adult'+ '</option>';
            }
            $('.travel-input #transfer_adults_count').html(select);
    
            var select = '';
            select += '<option value="0" selected="selected">0 child/teenager</option>'
            for (let i=1;i<=6;i++)
            {
                    select += '<option value=' + i + '>' + i +' child/teenager'+ '</option>';
            }
            $('.travel-input #transfer_child_count').html(select);
    
            
                $(".val-onchangetransfer").click(function()
                {

                    var room1_adults =  parseInt($("#transfer_adults_count").val()) ||0;
                    var room1_child =  parseInt($("#transfer_child_count").val()) ||0;

                    if(this.id=="transfer_adults_count")
                    {
                
                        var select_adult = '';
                        for (let i=1;i<=(9-room1_child);i++)
                        {
                            if(i==room1_adults)
                            {
                                select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                            }
                            else
                            {
                                select_adult += '<option value=' + i +'>' + i +' adult'+ '</option>';
                            }
                        }
            
                        for (let i=(10-room1_child);i<=(9);i++)
                        {
                            if(i==room1_adults)
                            {
                                select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                            }
                            {
                                select_adult += '<option value=' + i + ' + disabled="disabled">' + i +' adult'+ '</option>';
                            }
                        }
            
                            $('#transfer_adults_count').html(select_adult);
        
                            }
                    if(this.id=="transfer_child_count")
                    {
                        
                        if((9-room1_adults)<=6)
                        {
                        var select_child = '';
                        for (let i=0;i<=(9-room1_adults);i++)
                        {
                            if(i==room1_child)
                            {
                                select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                            }
                            else
                            {
                                select_child += '<option value=' + i +'>' + i +' child/teenager'+ '</option>';
                            }
                        }
            
                        for (let i=(10-room1_adults);i<=(6);i++)
                        {
                            if(i==room1_child)
                            {
                                select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                            }
                            {
                                select_child += '<option value=' + i + ' + disabled="disabled">' + i +' child/teenager'+ '</option>';
                            }
                        }
            
                        $('#transfer_child_count').html(select_child);
                    }
                }
                });
        }           
        dealsvalidation()
        {
            var select = '';
            select += '<option value="1" selected="selected">1 adult</option>'
            for (let i=2;i<=9;i++)
            {
                    select += '<option value=' + i + '>' + i +' adult'+ '</option>';
            }
            $('.trv-info .val_onchangedeals').html(select);
    
            var select = '';
            select += '<option value="0" selected="selected">0 child/teenager</option>'
            for (let i=1;i<=6;i++)
            {
                    select += '<option value=' + i + '>' + i +' child/teenager'+ '</option>';
            }
            $('.trv-info .val_onchangechilddeals').html(select);
    
            var select = '';
            select += '<option value="0" selected="selected">0 infant</option>'
            for (let i=1;i<=3;i++)
            {
                    select += '<option value=' + i + '>' + i +' infant'+ '</option>';
            }
            $('.trv-info .val_onchangeinfantdeals').html(select);
            
            $('.val_onchangechilddeals').on('change', function() {{

            if(this.id=="room1_child_count_deals")
            {
                var num = $("#room1_child_count_deals").val();
                $("#child_age_list_room1_deals").html("");
                
                for(var i=0; i<num ; i++){
                $("#child_age_list_room1_deals").append('<div class="control-label selectlist_child" id="child_age_list_room1_deals" for="adults_count">Child/Teenager '+ (i +1)+' age<div class="travel-input"> <select id="child_age" name="child_age"><option selected value="2">2 Years</option><option value="3">3 Years</option><option value="4">4 Years</option><option value="5">5 Years</option><option value="6">6 Years</option><option value="7">7 Years</option><option value="8">8 Years</option><option value="9">9 Years</option><option value="10">10 Years</option><option value="11">11 Years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div></div>');
                }
                if(num==0){
                    $("#child_age_list_room1_deals").html("<br/><br/>");
                }
            }
            if(this.id=="room2_child_count_deals")
            {
                var num = $("#room2_child_count_deals").val();
                $("#child_age_list_room2_deals").html("");
                
                for(var i=0; i<num ; i++){
                $("#child_age_list_room2_deals").append('<div class="control-label selectlist_child" id="child_age_list_room2_deals" for="adults_count">Child/Teenager '+ (i +1)+' age<div class="travel-input"> <select id="child_age" name="child_age"><option selected value="2">2 Years</option><option value="3">3 Years</option><option value="4">4 Years</option><option value="5">5 Years</option><option value="6">6 Years</option><option value="7">7 Years</option><option value="8">8 Years</option><option value="9">9 Years</option><option value="10">10 Years</option><option value="11">11 Years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div></div>');
                }
                if(num==0){
                    $("#child_age_list_room2_deals").html("<br/><br/>");
                }
            }
            if(this.id=="room3_child_count_deals")
            {
                var num = $("#room3_child_count_deals").val();
                $("#child_age_list_room3_deals").html("");
                
                for(var i=0; i<num ; i++){
                $("#child_age_list_room3_deals").append('<div class="control-label selectlist_child" id="child_age_list_room3_deals" for="adults_count">Child/Teenager '+ (i +1)+' age<div class="travel-input"> <select id="child_age" name="child_age"><option selected value="2">2 Years</option><option value="3">3 Years</option><option value="4">4 Years</option><option value="5">5 Years</option><option value="6">6 Years</option><option value="7">7 Years</option><option value="8">8 Years</option><option value="9">9 Years</option><option value="10">10 Years</option><option value="11">11 Years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div></div>');
                }
                if(num==0){
                    $("#child_age_list_room3_deals").html("<br/><br/>");
                }
            }
        }
            
        });
        $(".val_onchangedeals").click(function()
        {
            var room1_adults=0;
            var room1_child=0;
            var room2_adults=0;
            var room2_child=0;
            var room3_adults=0;
            var room3_child=0
            room1_adults =  parseInt($("#room1_adults_count_deals").val()) ||0;
            room1_child =  parseInt($("#room1_child_count_deals").val()) ||0;
            if(!$('#flightHotel_deals .room_two').hasClass('hide'))
            {
                 room2_adults =  parseInt($("#room2_adults_count_deals").val());
                room2_child =  parseInt($("#room2_child_count_deals").val()); 
            }
            if(!$('#flightHotel_deals .room_three').hasClass('hide'))
            {
                room3_adults =  parseInt($("#room3_adults_count_deals").val());
                room3_child =  parseInt($("#room3_child_count_deals").val());
            }
            if(this.id=="room1_adults_count_deals")
            {
                var totalcount=room1_child+room2_adults+room2_child+room3_adults+room3_child;
                var select_adult = '';
                for (let i=1;i<=(9-totalcount);i++)
                {
                    if(i==room1_adults)
                    {
                        select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                    }
                    else
                    {
                        select_adult += '<option value=' + i +'>' + i +' adult'+ '</option>';
                    }
                }
    
                for (let i=(10-totalcount);i<=(9);i++)
                {
                    if(i==room1_adults)
                    {
                        select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                    }
                    {
                        select_adult += '<option value=' + i + ' + disabled="disabled">' + i +' adult'+ '</option>';
                    }
                }
    
                $('#room1_adults_count_deals').html(select_adult);

            }
            if(this.id=="room2_adults_count_deals")
            {
                var totalcount=room1_child+room1_adults+room2_child+room3_adults+room3_child;
                var select_adult = '';
                for (let i=1;i<=(9-totalcount);i++)
                {
                    if(i==room2_adults)
                    {
                        select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                    }
                    else
                    {
                        select_adult += '<option value=' + i +'>' + i +' adult'+ '</option>';
                    }
                }
    
                for (let i=(10-totalcount);i<=(9);i++)
                {
                    if(i==room2_adults)
                    {
                        select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                    }
                    {
                        select_adult += '<option value=' + i + ' + disabled="disabled">' + i +' adult'+ '</option>';
                    }
                }
    
                $('#room2_adults_count_deals').html(select_adult);

            }
            if(this.id=="room3_adults_count_deals")
            {
                var totalcount=room1_child+room2_adults+room2_child+room1_adults+room3_child;
                var select_adult = '';
                for (let i=1;i<=(9-totalcount);i++)
                {
                    if(i==room3_adults)
                    {
                        select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                    }
                    else
                    {
                        select_adult += '<option value=' + i +'>' + i +' adult'+ '</option>';
                    }
                }
    
                for (let i=(10-totalcount);i<=(9);i++)
                {
                    if(i==room3_adults)
                    {
                        select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                    }
                    {
                        select_adult += '<option value=' + i + ' + disabled="disabled">' + i +' adult'+ '</option>';
                    }
                }
    
                $('#room3_adults_count_deals').html(select_adult);

            }
        });
        $(".val_onchangechilddeals").click(function()
        {
            var room1_adults=0;
            var room1_child=0;
            var room2_adults=0;
            var room2_child=0;
            var room3_adults=0;
            var room3_child=0
            room1_adults =  parseInt($("#room1_adults_count_deals").val()) ||0;
            room1_child =  parseInt($("#room1_child_count_deals").val()) ||0;
            if(!$('#flightHotel_deals .room_two').hasClass('hide'))
            {
                 room2_adults =  parseInt($("#room2_adults_count_deals").val());
                room2_child =  parseInt($("#room2_child_count_deals").val()); 
            }
            if(!$('#flightHotel_deals .room_three').hasClass('hide'))
            {
                room3_adults =  parseInt($("#room3_adults_count_deals").val());
                room3_child =  parseInt($("#room3_child_count_deals").val());
            }
            if(this.id=="room1_child_count_deals")
            {
                var totalcount=room1_adults+room2_adults+room2_child+room3_adults+room3_child;
                if((9-totalcount)<=6)
                {
                var select_child = '';
                for (let i=0;i<=(9-totalcount);i++)
                {
                    if(i==room1_child)
                    {
                        select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                    }
                    else
                    {
                        select_child += '<option value=' + i +'>' + i +' child/teenager'+ '</option>';
                    }
                }
    
                for (let i=(10-totalcount);i<=(6);i++)
                {
                    if(i==room1_child)
                    {
                        select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                    }
                    {
                        select_child += '<option value=' + i + ' + disabled="disabled">' + i +' child/teenager'+ '</option>';
                    }
                }
    
                $('#room1_child_count_deals').html(select_child);
            }
            }
            if(this.id=="room2_child_count_deals")
            {
                var totalcount=room1_adults+room2_adults+room1_child+room3_adults+room3_child;
                if((9-totalcount)<=6)
                {
                var select_child = '';
                for (let i=0;i<=(9-totalcount);i++)
                {
                    if(i==room2_child)
                    {
                        select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                    }
                    else
                    {
                        select_child += '<option value=' + i +'>' + i +' child/teenager'+ '</option>';
                    }
                }
    
                for (let i=(10-totalcount);i<=(6);i++)
                {
                    if(i==room2_child)
                    {
                        select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                    }
                    {
                        select_child += '<option value=' + i + ' + disabled="disabled">' + i +' child/teenager'+ '</option>';
                    }
                }
    
                $('#room2_child_count_deals').html(select_child);
            }
            }
            if(this.id=="room3_child_count_deals")
            {
                var totalcount=room1_adults+room2_adults+room2_child+room3_adults+room1_child;
                if((9-totalcount)<=6)
                {
                var select_child = '';
                for (let i=0;i<=(9-totalcount);i++)
                {
                    if(i==room3_child)
                    {
                        select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                    }
                    else
                    {
                        select_child += '<option value=' + i +'>' + i +' child/teenager'+ '</option>';
                    }
                }
    
                for (let i=(10-totalcount);i<=(6);i++)
                {
                    if(i==room3_child)
                    {
                        select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                    }
                    {
                        select_child += '<option value=' + i + ' + disabled="disabled">' + i +' child/teenager'+ '</option>';
                    }
                }
    
                $('#room3_child_count_deals').html(select_child);
            }
            }           
        });
        $(".val_onchangeinfantdeals").click(function()
        {
            var room1_adults =  parseInt($("#room1_adults_count_deals").val()) ||0;
            var room1_infant =  parseInt($("#room1_infants_count_deals").val())||0;
            var room2_adults =  parseInt($("#room2_adults_count_deals").val()) ||0;
            var room2_infant =  parseInt($("#room2_infants_count_deals").val())||0;
            var room3_adults =  parseInt($("#room3_adults_count_deals").val()) ||0;
            var room3_infant =  parseInt($("#room3_infants_count_deals").val())||0;
            if(room1_adults<=3)
            {
                var select_infant = '';
                for (let i=0;i<=(room1_adults);i++)
                {
                    if(i==room1_infant)
                    {
                        select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                    }
                    else
                    {
                        select_infant += '<option value=' + i +'>' + i +' infant'+ '</option>';
                    }
                }
                for (let i=(room1_adults+1);i<=(3);i++)
                {
                    if(i==room1_infant)
                    {
                        select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                    }
                    {
                        select_infant += '<option value=' + i + ' + disabled="disabled">' + i +' infant'+ '</option>';
                    }
                }
                $('#room1_infants_count_deals').html(select_infant);
            }
            if(room2_adults<=3)
            {
                var select_infant = '';
                for (let i=0;i<=(room2_adults);i++)
                {
                    if(i==room2_infant)
                    {
                        select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                    }
                    else
                    {
                        select_infant += '<option value=' + i +'>' + i +' infant'+ '</option>';
                    }
                }
                for (let i=(room2_adults+1);i<=(3);i++)
                {
                    if(i==room2_infant)
                    {
                        select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                    }
                    {
                        select_infant += '<option value=' + i + ' + disabled="disabled">' + i +' infant'+ '</option>';
                    }
                }
                $('#room2_infants_count_deals').html(select_infant);
            }
            if(room3_adults<=3)
            {
                var select_infant = '';
                for (let i=0;i<=(room3_adults);i++)
                {
                    if(i==room3_infant)
                    {
                        select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                    }
                    else
                    {
                        select_infant += '<option value=' + i +'>' + i +' infant'+ '</option>';
                    }
                }
                for (let i=(room3_adults+1);i<=(3);i++)
                {
                    if(i==room3_infant)
                    {
                        select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                    }
                    {
                        select_infant += '<option value=' + i + ' + disabled="disabled">' + i +' infant'+ '</option>';
                    }
                }
                $('#room3_infants_count_deals').html(select_infant);
            }
        });

    }

    flightHotelvalidation()
        {
            var select = '';
            select += '<option value="1" selected="selected">1 adult</option>'
            for (let i=2;i<=9;i++)
            {
                    select += '<option value=' + i + '>' + i +' adult'+ '</option>';
            }
            $('.trv-info .val_onchangeflighthotel').html(select);
    
            var select = '';
            select += '<option value="0" selected="selected">0 child/teenager</option>'
            for (let i=1;i<=6;i++)
            {
                    select += '<option value=' + i + '>' + i +' child/teenager'+ '</option>';
            }
            $('.trv-info .val_onchangechildflighthotel').html(select);
    
            var select = '';
            select += '<option value="0" selected="selected">0 infant</option>'
            for (let i=1;i<=3;i++)
            {
                    select += '<option value=' + i + '>' + i +' infant'+ '</option>';
            }
            $('.trv-info .val_onchangeinfantflighthotel').html(select);
            
            $('.val_onchangechildflighthotel').on('change', function() {{

            if(this.id=="room1_child_count_flighthotel")
            {
                var num = $("#room1_child_count_flighthotel").val();
                $("#child_age_list_room1_flighthotel").html("");
                
                for(var i=0; i<num ; i++){
                $("#child_age_list_room1_flighthotel").append('<div class="control-label selectlist_child" id="child_age_list_room1_flighthotel" for="adults_count">Child/Teenager '+ (i +1)+' age<div class="travel-input"> <select id="child_age" name="child_age"><option selected value="2">2 Years</option><option value="3">3 Years</option><option value="4">4 Years</option><option value="5">5 Years</option><option value="6">6 Years</option><option value="7">7 Years</option><option value="8">8 Years</option><option value="9">9 Years</option><option value="10">10 Years</option><option value="11">11 Years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div></div>');
                }
                if(num==0){
                    $("#child_age_list_room1_flighthotel").html("<br/><br/>");
                }
            }
            if(this.id=="room2_child_count_flighthotel")
            {
                var num = $("#room2_child_count_flighthotel").val();
                $("#child_age_list_room2_flighthotel").html("");
                
                for(var i=0; i<num ; i++){
                $("#child_age_list_room2_flighthotel").append('<div class="control-label selectlist_child" id="child_age_list_room2_flighthotel" for="adults_count">Child/Teenager '+ (i +1)+' age<div class="travel-input"> <select id="child_age" name="child_age"><option selected value="2">2 Years</option><option value="3">3 Years</option><option value="4">4 Years</option><option value="5">5 Years</option><option value="6">6 Years</option><option value="7">7 Years</option><option value="8">8 Years</option><option value="9">9 Years</option><option value="10">10 Years</option><option value="11">11 Years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div></div>');
                }
                if(num==0){
                    $("#child_age_list_room2_flighthotel").html("<br/><br/>");
                }
            }
            if(this.id=="room3_child_count_flighthotel")
            {
                var num = $("#room3_child_count_flighthotel").val();
                $("#child_age_list_room3_flighthotel").html("");
                
                for(var i=0; i<num ; i++){
                $("#child_age_list_room3_flighthotel").append('<div class="control-label selectlist_child" id="child_age_list_room3_flighthotel" for="adults_count">Child/Teenager '+ (i +1)+' age<div class="travel-input"> <select id="child_age" name="child_age"><option selected value="2">2 Years</option><option value="3">3 Years</option><option value="4">4 Years</option><option value="5">5 Years</option><option value="6">6 Years</option><option value="7">7 Years</option><option value="8">8 Years</option><option value="9">9 Years</option><option value="10">10 Years</option><option value="11">11 Years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div></div>');
                }
                if(num==0){
                    $("#child_age_list_room3_flighthotel").html("<br/><br/>");
                }
            }
        }
            
        });
        $(".val_onchangeflighthotel").click(function()
        {
            var room1_adults=0;
            var room1_child=0;
            var room2_adults=0;
            var room2_child=0;
            var room3_adults=0;
            var room3_child=0
            room1_adults =  parseInt($("#room1_adults_count_flighthotel").val()) ||0;
            room1_child =  parseInt($("#room1_child_count_flighthotel").val()) ||0;
            if(!$('#flightHotel_flighthotel .room_two').hasClass('hide'))
            {
                 room2_adults =  parseInt($("#room2_adults_count_flighthotel").val());
                room2_child =  parseInt($("#room2_child_count_flighthotel").val()); 
            }
            if(!$('#flightHotel_flighthotel .room_three').hasClass('hide'))
            {
                room3_adults =  parseInt($("#room3_adults_count_flighthotel").val());
                room3_child =  parseInt($("#room3_child_count_flighthotel").val());
            }
            if(this.id=="room1_adults_count_flighthotel")
            {
                var totalcount=room1_child+room2_adults+room2_child+room3_adults+room3_child;
                var select_adult = '';
                for (let i=1;i<=(9-totalcount);i++)
                {
                    if(i==room1_adults)
                    {
                        select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                    }
                    else
                    {
                        select_adult += '<option value=' + i +'>' + i +' adult'+ '</option>';
                    }
                }
    
                for (let i=(10-totalcount);i<=(9);i++)
                {
                    if(i==room1_adults)
                    {
                        select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                    }
                    {
                        select_adult += '<option value=' + i + ' + disabled="disabled">' + i +' adult'+ '</option>';
                    }
                }
    
                $('#room1_adults_count_flighthotel').html(select_adult);

            }
            if(this.id=="room2_adults_count_flighthotel")
            {
                var totalcount=room1_child+room1_adults+room2_child+room3_adults+room3_child;
                var select_adult = '';
                for (let i=1;i<=(9-totalcount);i++)
                {
                    if(i==room2_adults)
                    {
                        select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                    }
                    else
                    {
                        select_adult += '<option value=' + i +'>' + i +' adult'+ '</option>';
                    }
                }
    
                for (let i=(10-totalcount);i<=(9);i++)
                {
                    if(i==room2_adults)
                    {
                        select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                    }
                    {
                        select_adult += '<option value=' + i + ' + disabled="disabled">' + i +' adult'+ '</option>';
                    }
                }
    
                $('#room2_adults_count_flighthotel').html(select_adult);

            }
            if(this.id=="room3_adults_count_flighthotel")
            {
                var totalcount=room1_child+room2_adults+room2_child+room1_adults+room3_child;
                var select_adult = '';
                for (let i=1;i<=(9-totalcount);i++)
                {
                    if(i==room3_adults)
                    {
                        select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                    }
                    else
                    {
                        select_adult += '<option value=' + i +'>' + i +' adult'+ '</option>';
                    }
                }
    
                for (let i=(10-totalcount);i<=(9);i++)
                {
                    if(i==room3_adults)
                    {
                        select_adult += '<option value=' + i + ' + selected="selected">' + i +' adult'+ '</option>';
                    }
                    {
                        select_adult += '<option value=' + i + ' + disabled="disabled">' + i +' adult'+ '</option>';
                    }
                }
    
                $('#room3_adults_count_flighthotel').html(select_adult);

            }
        });
        $(".val_onchangechildflighthotel").click(function()
        {
            var room1_adults=0;
            var room1_child=0;
            var room2_adults=0;
            var room2_child=0;
            var room3_adults=0;
            var room3_child=0
            room1_adults =  parseInt($("#room1_adults_count_flighthotel").val()) ||0;
            room1_child =  parseInt($("#room1_child_count_flighthotel").val()) ||0;
            if(!$('#flightHotel2 .room_two').hasClass('hide'))
            {
                 room2_adults =  parseInt($("#room2_adults_count_flighthotel").val());
                room2_child =  parseInt($("#room2_child_count_flighthotel").val()); 
            }
            if(!$('#flightHotel2 .room_three').hasClass('hide'))
            {
                room3_adults =  parseInt($("#room3_adults_count_flighthotel").val());
                room3_child =  parseInt($("#room3_child_count_flighthotel").val());
            }
            if(this.id=="room1_child_count_flighthotel")
            {
                var totalcount=room1_adults+room2_adults+room2_child+room3_adults+room3_child;
                if((9-totalcount)<=6)
                {
                var select_child = '';
                for (let i=0;i<=(9-totalcount);i++)
                {
                    if(i==room1_child)
                    {
                        select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                    }
                    else
                    {
                        select_child += '<option value=' + i +'>' + i +' child/teenager'+ '</option>';
                    }
                }
    
                for (let i=(10-totalcount);i<=(6);i++)
                {
                    if(i==room1_child)
                    {
                        select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                    }
                    {
                        select_child += '<option value=' + i + ' + disabled="disabled">' + i +' child/teenager'+ '</option>';
                    }
                }
    
                $('#room1_child_count_flighthotel').html(select_child);
            }
            }
            if(this.id=="room2_child_count_flighthotel")
            {
                var totalcount=room1_adults+room2_adults+room1_child+room3_adults+room3_child;
                if((9-totalcount)<=6)
                {
                var select_child = '';
                for (let i=0;i<=(9-totalcount);i++)
                {
                    if(i==room2_child)
                    {
                        select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                    }
                    else
                    {
                        select_child += '<option value=' + i +'>' + i +' child/teenager'+ '</option>';
                    }
                }
    
                for (let i=(10-totalcount);i<=(6);i++)
                {
                    if(i==room2_child)
                    {
                        select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                    }
                    {
                        select_child += '<option value=' + i + ' + disabled="disabled">' + i +' child/teenager'+ '</option>';
                    }
                }
    
                $('#room2_child_count_flighthotel').html(select_child);
            }
            }
            if(this.id=="room3_child_count_flighthotel")
            {
                var totalcount=room1_adults+room2_adults+room2_child+room3_adults+room1_child;
                if((9-totalcount)<=6)
                {
                var select_child = '';
                for (let i=0;i<=(9-totalcount);i++)
                {
                    if(i==room3_child)
                    {
                        select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                    }
                    else
                    {
                        select_child += '<option value=' + i +'>' + i +' child/teenager'+ '</option>';
                    }
                }
    
                for (let i=(10-totalcount);i<=(6);i++)
                {
                    if(i==room3_child)
                    {
                        select_child += '<option value=' + i + ' + selected="selected">' + i +' child/teenager'+ '</option>';
                    }
                    {
                        select_child += '<option value=' + i + ' + disabled="disabled">' + i +' child/teenager'+ '</option>';
                    }
                }
    
                $('#room3_child_count_flighthotel').html(select_child);
            }
            }           
        });
        $(".val_onchangeinfantflighthotel").click(function()
        {
            var room1_adults =  parseInt($("#room1_adults_count_flighthotel").val()) ||0;
            var room1_infant =  parseInt($("#room1_infants_count_flighthotel").val())||0;
            var room2_adults =  parseInt($("#room2_adults_count_flighthotel").val()) ||0;
            var room2_infant =  parseInt($("#room2_infants_count_flighthotel").val())||0;
            var room3_adults =  parseInt($("#room3_adults_count_flighthotel").val()) ||0;
            var room3_infant =  parseInt($("#room3_infants_count_flighthotel").val())||0;
            if(room1_adults<=3)
            {
                var select_infant = '';
                for (let i=0;i<=(room1_adults);i++)
                {
                    if(i==room1_infant)
                    {
                        select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                    }
                    else
                    {
                        select_infant += '<option value=' + i +'>' + i +' infant'+ '</option>';
                    }
                }
                for (let i=(room1_adults+1);i<=(3);i++)
                {
                    if(i==room1_infant)
                    {
                        select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                    }
                    {
                        select_infant += '<option value=' + i + ' + disabled="disabled">' + i +' infant'+ '</option>';
                    }
                }
                $('#room1_infants_count_flighthotel').html(select_infant);
            }
            if(room2_adults<=3)
            {
                var select_infant = '';
                for (let i=0;i<=(room2_adults);i++)
                {
                    if(i==room2_infant)
                    {
                        select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                    }
                    else
                    {
                        select_infant += '<option value=' + i +'>' + i +' infant'+ '</option>';
                    }
                }
                for (let i=(room2_adults+1);i<=(3);i++)
                {
                    if(i==room2_infant)
                    {
                        select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                    }
                    {
                        select_infant += '<option value=' + i + ' + disabled="disabled">' + i +' infant'+ '</option>';
                    }
                }
                $('#room2_infants_count_flighthotel').html(select_infant);
            }
            if(room3_adults<=3)
            {
                var select_infant = '';
                for (let i=0;i<=(room3_adults);i++)
                {
                    if(i==room3_infant)
                    {
                        select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                    }
                    else
                    {
                        select_infant += '<option value=' + i +'>' + i +' infant'+ '</option>';
                    }
                }
                for (let i=(room3_adults+1);i<=(3);i++)
                {
                    if(i==room3_infant)
                    {
                        select_infant += '<option value=' + i + ' + selected="selected">' + i +' infant'+ '</option>';
                    }
                    {
                        select_infant += '<option value=' + i + ' + disabled="disabled">' + i +' infant'+ '</option>';
                    }
                }
                $('#room3_infants_count_flighthotel').html(select_infant);
            }
        });
    }
}
let scope: any = document.querySelector('.searchFlightHotel');
let mHolidaysBase:any = new mHolidays();

if (scope) {
    try {
        window['mHolidaysHotelsList'] = $.Deferred();
		mHolidaysBase.hotelListNew().done((listData: any) => {
			window['mHolidaysHotelsList'].resolve(listData);
		});
		window['mHolidaysHotelsList'].promise();
        window['mHolidaysPdpHotelsList'] = $.Deferred();
		mHolidaysBase.pdpHotelList().done((listData: any) => {
			window['mHolidaysPdpHotelsList'].resolve(listData);
		});
		window['mHolidaysPdpHotelsList'].promise();
        let bookflight = new flightHotelFormContent();
        bookflight.init();
        bookflight.initCalendar();
        bookflight.inittransferCalendar();
        bookflight.inputFormFocus();
        bookflight.timesetings();
        bookflight.travelrvalidation_flight();
        bookflight.travelrvalidation_hotel();
        bookflight.travelrvalidation_transfer();
        bookflight.dealsvalidation();
        bookflight.flightHotelvalidation();
        mHolidaysBase.populateTuiHotelList($('#hotel'));
        mHolidaysBase.populateTuiHotelList($('#flightHotel2'));
        mHolidaysBase.transfermHolidayslist($('#transferdrop'));
        mHolidaysBase.mhcabinclass('#flightHotel');
        mHolidaysBase.transferPickupmHolidayslist($('#transferpickup'));
        mHolidaysBase.tourmHolidayslist($('#tourInputWrap'));    
        // mHolidaysBase.populateTuiHotelList($('.pick-up'));
        // mHolidaysBase.populateTuiHotelList($('.drop-off'));
        mHolidaysBase.mHolidayslist().done((listData: any) => {
            bookflight.initSelectize(mHolidaysBase.parseOnDListItems(listData, 'mholiday'));
            bookflight.initSelectize_deals(mHolidaysBase.parseOnDListItems(listData, 'mholiday'));
            bookflight.searchFormSubmitHandler($('.searchFlightHotel'));
        });
        mHolidaysBase.pdpMholidayList().done((listData: any) => {
            bookflight.initSelectize_flighthotel(mHolidaysBase.parseOnDListItems(listData,'mholiday'));
        });
    } catch (e) { console.error(e); }
}